import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectorRef, OnDestroy, ElementRef, ViewChildren, QueryList, EventEmitter, Output, Input, SimpleChanges, OnChanges } from '@angular/core';
import { HowDoIVideoLinks, UTCDateTime, mileageRatedigitConfig } from "src/app/common/commonvariables";
import {
  ApiRequest, IRequestVehicleTypes, RequestVehicleTypes, IApiresponse,
  IOrgUKMileageVehicleTypes, OrgUKMileageVehicleTypes, VehicleTypeEnum, VehicleSubTypeEnum, MileageRateStatusEnum, MileageRateTypeEnum, IOrgUKRateSelectedVehiclesResponse
  , OrgUKRateSelectedVehiclesResponse, UKRateConfigEnum, FunctionPackageEnum, LogObjectActionTemplateEnum, IOrgVehicleTypeResponse, IVehicleList, PanelClosActionEnum, NRFCStatusEnum,
  ElectricChargingType
} from 'src/app/_models';
import { environment } from 'src/environments/environment';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { UkMileageRateSettingService } from 'src/app/_services/advance-mileage/uk-mileage-rate-setting.service';
import { IOrgUKRatesByOrgMapIdResponse } from 'src/app/_models/advance-mileage/org-ukrates-by-org-map-id-response';
import { CloseFormAction, IOrgUKMileageRateInfo, OrgOwnershipTypeInfo } from 'src/app/_models/advance-mileage/org-ukmileage-rate-info';
import { CommonModule, DatePipe, formatDate } from '@angular/common';
import { UntypedFormGroup, FormBuilder, UntypedFormArray, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared.module';
import { MileageMultiRateInfo } from 'src/app/_models/advance-mileage/mileage-multi-rate-info';
import { ITaxRateMasterResponse, TaxRateMasterResponse } from 'src/app/_models/manage-category/tax-rate-master-response';
import { IVehicleTypeMasterInfo } from 'src/app/_models/advance-mileage/vehicle-type-master-info';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { SaveOwnershiptypeRequest, UkRateInfo } from 'src/app/_models/advance-mileage/uk-rate-info';
import { ISaveOrgMileageWizardResponse } from 'src/app/_models/advance-mileage/save-org-mileage-wizard-response';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { UkMileageRateSettingConfiguration } from 'src/app/_models/advance-mileage/uk-mileage-rate-setting-configuration';
import { IValidateEffectiveDateRequest, ValidateEffectiveDateRequest } from 'src/app/_models/advance-mileage/validate-effective-date-request';
import { ClaimsService } from 'src/app/_services/common/claims.service';
import { ICartDetailsRequest, CartDetailsRequest } from 'src/app/_models/organisation-setting/organisation-setting';
import { RSAHelper } from 'src/app/_helpers/RSAHelper';
import { ValidateOwnershipNameRequest } from 'src/app/_models/advance-mileage/validate-ownership-name-request';
import { BaseComponent } from 'src/app/shared/base/base-component';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/alert-panel/alert.service';
import { IValidateOwnershipDeactiveRequest, ValidateOwnershipDeactiveRequest } from 'src/app/_models/advance-mileage/validate-ownership-deactive-request';
import { MarketingPopup } from 'src/app/_models/common/marketing-popup';
import { IPurchaseFunctionListRequest, PurchaseFunctionListRequest } from 'src/app/_models/organisation-setting/organisation-setting';
import { Claims } from 'src/app/_models/common/claims';
import { LoggingPanelService } from 'src/app/_services/logging-panel/logging-panel.service';
import { OrganisationSettingService } from 'src/app/_services/organisation-setting/organisation-setting.service';
import { LoggingPanelModel } from 'src/app/_models/common/LoggingPanelModel';
import { ManageempService } from 'src/app/_services';
import { IOrgVehiclesNRFCRequest, OrgVehiclesNRFCRequest } from 'src/app/_models/NrFc/org-vehicles-nrfcrequest';
import { NrFcService } from 'src/app/_services/NrFc/nr-fc.service';
import { IOrgVehiclesNRFCResponse } from 'src/app/_models/NrFc/org-vehicles-nrfcresponse';
import { AlertPanelModel } from 'src/app/_models/common/alertPanelModel';
import { DomSanitizer } from '@angular/platform-browser';
import { TaxSetupRequest, TaxSetupRequestInfo } from 'src/app/_models/tax-rate/tax-setup-request';
import { TaxRateService } from 'src/app/_services/tax-rate/tax-rate.service';
import { TourService } from "../../../_tour/tour.service";
import { TaxSetupStep2Component } from 'src/app/tax-rate-setup/tax-setup-step2/tax-setup-step2.component';
@Component({
  selector: 'uk-mileage-rate-setting-panel',
  templateUrl: './uk-mileage-rate-setting-panel.component.html',
  styleUrls: ['./uk-mileage-rate-setting-panel.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule,
    TaxSetupStep2Component
  ]
})
export class UkMileageRateSettingPanelComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @Output() closePanelEvent = new EventEmitter<any>();
  @Input() formData: any;
  @Output() closePanelRateImport = new EventEmitter<any>();
  @Output() openAssignVehicleEvent = new EventEmitter<any>();
  @Input("PanelData") PanelData: any;
  ukMileageRateSettingConfiguration: UkMileageRateSettingConfiguration = new UkMileageRateSettingConfiguration();
  formctrl: UntypedFormGroup;
  isPassengerLoadPurchased: boolean;
  howDoIVideoLinks = HowDoIVideoLinks;
  gridHeaderResult = <IOrgUKMileageVehicleTypes[]>[];
  panelClosActionEnum: PanelClosActionEnum;
  vehicleTypeDetail: IOrgUKMileageVehicleTypes;
  selectedOrgUKMileageVehicleTypes: IOrgUKMileageVehicleTypes = new OrgUKMileageVehicleTypes();
  orgUKRatesByOrgMapIdResponse: IOrgUKRatesByOrgMapIdResponse;
  orgUKRateSelectedVehiclesResponse: IOrgUKRateSelectedVehiclesResponse;
  orgUKMileageRateInfoList = <IOrgUKMileageRateInfo[]>[];
  taxRateMasterResponse = <any[]>[];
  vehicleTypeMasterInfoList = <IVehicleTypeMasterInfo[]>[];
  ownershipTemplateDetail: IVehicleTypeMasterInfo;
  vatRateDetail: ITaxRateMasterResponse;
  setupVehHeader: string;
  orgUKMileageRateInfo: OrgOwnershipTypeInfo = new OrgOwnershipTypeInfo();
  public param: string;
  vehicleTypeEnum = VehicleTypeEnum;
  vehicleSubTypeEnum = VehicleSubTypeEnum;
  mileageRateStatusEnum = MileageRateStatusEnum;
  mileageRateTypeEnum = MileageRateTypeEnum;
  uKRateConfigEnum = UKRateConfigEnum;
  functionPackageEnum = FunctionPackageEnum;
  claims: Claims;
  logItemId: string;
  passengerLoadDisplay: boolean;
  datePickerOptions: FlatpickrOptions = {
    mode: "single",
    defaultDate: new Date(),
    altInput: true,
    altFormat: "d-M-Y",
    dateFormat: "d-M-Y"
  };
  @ViewChild("fFrmDate") fFrmDate: any;
  gridFilterItems = [
    { id: MileageRateStatusEnum.All, name: this.translate.instant("uk_mileage_all_rates") },
    { id: MileageRateStatusEnum.Active, name: this.translate.instant("uk_mileage_current_rates") },
    { id: MileageRateStatusEnum.FutureRate, name: this.translate.instant("uk_mileage_future_rates") }
  ];
  watchVideoUrl: string;
  userActionEventSubscription: Subscription;
  @ViewChild('subNavMenuContainer', { read: ElementRef }) subNavMenuContainer: ElementRef<any>;
  @ViewChildren('navLink') navLinks: QueryList<ElementRef>;
  scrollVisible: boolean = false;
  scrollRightVisible: boolean = true;
  scrollLeftVisible: boolean = true;
  EditClickAction: boolean = false;
  activeVehicleTypeDropdown = <IVehicleList[]>[];
  orgVehicleTypeResponse: IOrgVehicleTypeResponse;
  isOverlayRequired = true;
  closeFormAction: CloseFormAction = new CloseFormAction();
  maxFuelRate: any;
  nrfuelRateDefault: number = 0.001;
  homeChargingEnabled: boolean = true;
  thirdPartyChargingEnabled: boolean = true;
  originalChargingType: number = 0;
  purchaseFunctionList: number[] = [];
  isFCPurchased: boolean;
  isNRPurchased: boolean;
  isDOCPurchased: boolean;
  isFCassignedToOwnership: boolean;
  requestVehicleTypes: OrgVehiclesNRFCRequest = new OrgVehiclesNRFCRequest();
  taxRatePopupModel: MarketingPopup;
  isActive: boolean;
  totalActiveVehicleForReferesh: number;
  constructor(private ukMileageRateSettingService: UkMileageRateSettingService, private fb: FormBuilder, public datepipe: DatePipe
    , private toastr: ToastrService, private translate: TranslateService
    , private cdRef: ChangeDetectorRef, private router: Router, private claimsService: ClaimsService,
    private alertService: AlertService, private loggingPanelService: LoggingPanelService,
    private organisationSettingService: OrganisationSettingService, private manageEmpService: ManageempService,
    private nrFcService: NrFcService, private sanitizer: DomSanitizer, private taxRateService: TaxRateService,
    private tourService: TourService, private route: ActivatedRoute) {
    super();

    this.claimsService.currentClaims.subscribe(claims => {
      this.ukMileageRateSettingConfiguration.claims = claims;
      this.claims = claims;
    });

    this.BindTaxSetup();
    let rateList = [];
    let rate = new MileageMultiRateInfo();
    rateList.push(rate);
    this.orgUKMileageRateInfo.mileageMultiRateInfoList = rateList;
    this.orgUKRateSelectedVehiclesResponse = new OrgUKRateSelectedVehiclesResponse;
    this.ukMileageRateSettingConfiguration.isDeleteRateBtnHide = true;
    this.observeUnsavedChangesAlerts();
  }
  get formUk() { return this.formctrl.controls; }
  ngOnInit() {
    this.passengerLoadDisplay = false;
    this.isPassengerLoadPurchased = false;
    let listMileageMultiRateInfo = [];
    for (let i = 0; i < this.orgUKMileageRateInfo.mileageMultiRateInfoList.length; i++) {
      listMileageMultiRateInfo.push(this.BuildFormDynamic(this.orgUKMileageRateInfo.mileageMultiRateInfoList[i], this.ukMileageRateSettingConfiguration.minMileageRate));
    }
    this.formctrl = this.fb.group({
      effectiveFrom: ['', [Validators.required]],
      nrFuelRate: [this.nrfuelRateDefault, [Validators.required]],
      derivedName: [null, [Validators.required]],
      orgVehicleTypeMapId: [0],
      vehicleSubTypeId: [null],
      concatVehicleTypeId: [null],
      vehicleLabel: ['', [Validators.required]],
      resetDate: this.PanelData?.currentFinancialYear,
      isActive: [false],
      mileageMultiRateInfoList: this.fb.array(listMileageMultiRateInfo),
      vatRate: [0],
      vatRateId: [0],
      mileageRate: [0, [Validators.required]],
    });
    this.getOrgPurchaseFunctionList();
    this.fnGetOrgVehicleType();
    this.fnStartTour();

  }
  ngOnChanges(changes: SimpleChanges) {
    this.getOrgPurchaseFunctionList();
    this.fnGetOrgVehicleType();
    if (this.formData) {
      this.totalActiveVehicleForReferesh = this.formData.totalActiveVehicle
      this.isOverlayRequired = this.formData.isOverlayRequired;
      if (this.formData.userActionId && (this.formData.userActionId == UKRateConfigEnum.AddNewRate || this.formData.userActionId == UKRateConfigEnum.AddNewOwnership)) {
        this.ukMileageRateSettingConfiguration.isCopyIconHide = true;
        if (this.formData.userActionId == UKRateConfigEnum.AddNewRate) {
          this.fnAddRate();
        }
        else if (this.formData.userActionId == UKRateConfigEnum.AddNewOwnership) {
          this.fnAddOwnershipType();
        }
      }
      else {
        this.selectedOrgUKMileageVehicleTypes.derivedName = this.formData.rowData.baseName;
        this.selectedOrgUKMileageVehicleTypes.isActive = this.formData.rowData.isActive;
        this.selectedOrgUKMileageVehicleTypes.isMultiRange = this.formData.rowData.isMultiRange;
        this.selectedOrgUKMileageVehicleTypes.isSelected = true;
        this.selectedOrgUKMileageVehicleTypes.orgVehicleTypeMapId = this.formData.rowData.orgVehicleTypeMapId;
        this.selectedOrgUKMileageVehicleTypes.sequence = 1;
        this.selectedOrgUKMileageVehicleTypes.vehicleLabel = this.formData.rowData.vehicleLabel;
        this.selectedOrgUKMileageVehicleTypes.vehicleSubTypeId = this.formData.rowData.vehicleSubTypeId;
        this.selectedOrgUKMileageVehicleTypes.vehicleTypeId = this.formData.rowData.vehicleTypeId;
        const ct: number = this.formData.rowData.chargingType || 0;
        this.originalChargingType = ct;
        this.homeChargingEnabled = ct === 0 || ct === ElectricChargingType.HomeCharging || ct === ElectricChargingType.Both;
        this.thirdPartyChargingEnabled = ct === 0 || ct === ElectricChargingType.ThirdPartyCharging || ct === ElectricChargingType.Both;
        this.maxFuelRate = Math.max.apply(Math, this.formData.rowData.mileageMultiRateInfoList.map(function (o) { return o.mileageRate; }));
        if (this.claims.RateType == MileageRateTypeEnum.FreeForLife) {
          this.nrfuelRateDefault = 0.00;
        }
        else {
          this.nrfuelRateDefault = this.formData.rowData.nrFuelRate;
        }
        this.selectedOrgUKMileageVehicleTypes.concatVehicleTypeId = Number(String(this.selectedOrgUKMileageVehicleTypes.vehicleTypeId) + String(this.selectedOrgUKMileageVehicleTypes.vehicleSubTypeId));
        if (this.formData.rowData && this.formData.rowData.orgVehicleTypeMapId) {
          this.GetOrgVehicleNRFCDetails(this.formData.rowData);
        }
        else {
          this.fnEditOrgUKMileageRateInfo(this.formData.rowData);
        }
      }
    }
  }

  fnGetOrgVehicleType() {
    let request = new ApiRequest<IRequestVehicleTypes>("GetOrgVehicleType", environment.applicationVersion, environment.requestId);
    let requestInfo = new RequestVehicleTypes();
    request.requestInfo = requestInfo;
    this.manageEmpService
      .GetOrgVehcileTypeList(request)
      .subscribe((response: IApiresponse<IOrgVehicleTypeResponse>) => {
        this.orgVehicleTypeResponse = response.responseInfo;
        this.activeVehicleTypeDropdown = this.orgVehicleTypeResponse.vehicleTypes.filter(a => a.vehicleTypeId != VehicleTypeEnum.No_Vehicle)
      });
  }

  fnShowConfigureshowLoggingAlertPanel() {
    const model = new LoggingPanelModel(
      this.claims.OrgId.toString(),
      LogObjectActionTemplateEnum.SetupUKRatesOwnershipType.toString(),
      "0",
      this.logItemId
    );
    this.loggingPanelService.onShowLogPanel(model);
  }
  ngAfterViewInit() {
    this.fFrmDate.nativeElement.flatpickr(this.datePickerOptions);
  }
  fnInitializeForm() {
    setTimeout(() => {
      this.formctrl.controls.nrFuelRate.setErrors(null);
      this.cdRef.detectChanges();
    }, 100);
    let minMileageRate = 0.01;
    let listMileageMultiRateInfo = [];
    // Normalize chargingType for Electric Car rates that may have been stored as 0 (old data)
    if (this.isElectricCar) {
      this.orgUKMileageRateInfo.mileageMultiRateInfoList.forEach((rate, i) => {
        if (!rate.chargingType) { rate.chargingType = i === 0 ? 1 : 2; }
      });
    }
    for (let i = 0; i < this.orgUKMileageRateInfo.mileageMultiRateInfoList.length; i++) {
      if (this.claims.RateType == this.mileageRateTypeEnum.DifferentialRate && i > 0) {
        minMileageRate = 0;
      }
      listMileageMultiRateInfo.push(this.BuildFormDynamic(this.orgUKMileageRateInfo.mileageMultiRateInfoList[i], minMileageRate));
    }
    if (this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewRate) {
      this.ukMileageRateSettingConfiguration.oldVehicleLabel = this.vehicleTypeDetail.vehicleLabel;
      this.formctrl = this.fb.group({
        effectiveFrom: [this.datepipe.transform(this.orgUKMileageRateInfo.effectiveFrom, 'dd-MMM-yyyy'), [Validators.required]],
        nrFuelRate: [this.nrfuelRateDefault, [Validators.required]],
        derivedName: [this.vehicleTypeDetail.derivedName],
        orgVehicleTypeMapId: [this.vehicleTypeDetail.orgVehicleTypeMapId],
        vehicleSubTypeId: [this.vehicleTypeDetail.vehicleSubTypeId],
        concatVehicleTypeId: [this.vehicleTypeDetail.concatVehicleTypeId],
        vehicleLabel: [this.vehicleTypeDetail.vehicleLabel, [Validators.required]],
        resetDate: this.datepipe.transform(this.PanelData?.currentFinancialYear, 'dd-MMM'),
        isActive: [this.vehicleTypeDetail.isActive],
        mileageMultiRateInfoList: this.fb.array(listMileageMultiRateInfo),
        vatRate: [0],
        vatRateId: [0],
        mileageRate: [this.orgUKMileageRateInfo.mileageMultiRateInfoList[0].mileageRate, [Validators.required]],
      });
    }
    else {
      let isActive = this.selectedOrgUKMileageVehicleTypes.isActive;
      if (isActive != null && isActive != undefined && isActive) {
        this.ukMileageRateSettingConfiguration.isActivateValidationDisplay = false;
      }
      else {
        this.ukMileageRateSettingConfiguration.isActivateValidationDisplay = true;
      }
      this.ukMileageRateSettingConfiguration.oldVehicleLabel = this.selectedOrgUKMileageVehicleTypes.vehicleLabel;
      this.formctrl = this.fb.group({
        effectiveFrom: [this.datepipe.transform(this.orgUKMileageRateInfo.effectiveFrom, 'dd-MMM-yyyy'), [Validators.required]],
        nrFuelRate: [this.orgUKMileageRateInfo.nrFuelRate > 0 ? this.orgUKMileageRateInfo.nrFuelRate : this.nrfuelRateDefault, [Validators.required]],
        derivedName: [this.selectedOrgUKMileageVehicleTypes.derivedName],
        orgVehicleTypeMapId: [this.selectedOrgUKMileageVehicleTypes.orgVehicleTypeMapId],
        vehicleSubTypeId: [this.selectedOrgUKMileageVehicleTypes.vehicleSubTypeId],
        concatVehicleTypeId: [this.selectedOrgUKMileageVehicleTypes.concatVehicleTypeId],
        vehicleLabel: [this.selectedOrgUKMileageVehicleTypes.vehicleLabel, [Validators.required]],
        resetDate: this.datepipe.transform(this.PanelData?.currentFinancialYear, 'dd-MMM'),
        isActive: [this.selectedOrgUKMileageVehicleTypes.isActive],
        mileageMultiRateInfoList: this.fb.array(listMileageMultiRateInfo),
        vatRate: [this.fnGetVatRate(this.orgUKMileageRateInfo.mileageMultiRateInfoList[0].vatRateId, true)],
        vatRateId: [this.orgUKMileageRateInfo.mileageMultiRateInfoList[0].vatRateId],
        mileageRate: [this.orgUKMileageRateInfo.mileageMultiRateInfoList[0].mileageRate != undefined
          ? this.orgUKMileageRateInfo.mileageMultiRateInfoList[0].mileageRate.toFixed(mileageRatedigitConfig)
          : this.orgUKMileageRateInfo.mileageMultiRateInfoList[0].mileageRate, [Validators.required]],
      });
    }

    this.fnSetCalendar(this.orgUKMileageRateInfo.effectiveFrom);
    if (this.isElectricCar) {
      this.formctrl.controls.nrFuelRate.clearValidators();
      this.formctrl.controls.nrFuelRate.setValue(0, { emitEvent: false });
      this.formctrl.controls.nrFuelRate.updateValueAndValidity();
      this.formctrl.controls.mileageRate.clearValidators();
      this.formctrl.controls.mileageRate.setValue(0, { emitEvent: false });
      this.formctrl.controls.mileageRate.updateValueAndValidity();

      // Ensure formGroup 0 retains its model values for Electric Car (prevent blank fields on certain scenarios).
      if (this.mileageMultiRateInfoListArray && this.mileageMultiRateInfoListArray.length > 0) {
        const firstRate = this.orgUKMileageRateInfo?.mileageMultiRateInfoList?.[0];
        if (firstRate) {
          const patchedNrFuel = firstRate.nrFuelRate != undefined ? Number(firstRate.nrFuelRate).toFixed(mileageRatedigitConfig) : '0.0000';
          const patchedMileage = firstRate.mileageRate != undefined ? Number(firstRate.mileageRate).toFixed(mileageRatedigitConfig) : '0.0000';
          this.mileageMultiRateInfoListArray.at(0).patchValue({
            nrFuelRate: patchedNrFuel,
            mileageRate: patchedMileage
          }, { emitEvent: false });
        }
      }
    }
    this.fnMileageRateEnable();
    this.cdRef.detectChanges();

  }

  fnSetCalendar(effectiveFrom) {
    let todayDate = new Date();
    let effdateShort = formatDate(effectiveFrom, 'dd-MMM-yyyy', 'en-US');
    let effDateFormat = new Date(effdateShort);
    switch (this.ukMileageRateSettingConfiguration.userActionId) {
      case this.uKRateConfigEnum.ActivateOwnerShip:
        let finalEffDate = new Date(this.datepipe.transform(new Date(parseInt(effectiveFrom)), "yyyy-MM-dd"));
        this.fFrmDate.nativeElement
          .flatpickr({
            mode: "single",
            dateFormat: "d-M-Y",
            defaultDate: finalEffDate,
            maxDate: new Date(),
            altInput: true,
            altFormat: "d-M-Y"
          });
        break;
      case this.uKRateConfigEnum.ActiveRateEdit:
        this.fFrmDate.nativeElement
          .flatpickr({
            mode: "single",
            dateFormat: "d-M-Y",
            defaultDate: effDateFormat,
            altInput: true,
            altFormat: "d-M-Y"
          });
        break;
      case this.uKRateConfigEnum.AddNewOwnership:
        this.fFrmDate.nativeElement
          .flatpickr({
            mode: "single",
            dateFormat: "d-M-Y",
            defaultDate: effDateFormat,
            maxDate: new Date(),
            altInput: true,
            altFormat: "d-M-Y"
          });
        this.formctrl.patchValue({
          effectiveFrom: effDateFormat
        });
        break;
      case this.uKRateConfigEnum.AddNewRate:
      case this.uKRateConfigEnum.CopyRate:
      case this.uKRateConfigEnum.FutureRateEdit:
        todayDate.setDate(todayDate.getDate() + 1);
        let todayDateShort = formatDate(todayDate, 'dd-MMM-yyyy', 'en-US');
        let todayDateFormat = new Date(todayDateShort);
        this.fFrmDate.nativeElement
          .flatpickr({
            mode: "single",
            dateFormat: "d-M-Y",
            defaultDate: effdateShort,
            minDate: todayDateFormat,
            altInput: true,
            altFormat: "d-M-Y"
          });
        break;
    }
    this.cdRef.detectChanges();
  }
  taxSetupRequestInfo: TaxSetupRequestInfo;
  IsTaxRateOn: boolean;
  IsSingleRate: any;
  BindTaxSetup() {
    var request = new TaxSetupRequest();
    request.requestId = "1";
    request.webApiName = "GetTaxSetup";
    request.webApiVersion = 1;
    request.requestInfo = new TaxSetupRequestInfo();
    request.requestInfo.organisationId = this.claims.OrgId;

    this.taxRateService
      .getTaxSetuByOrg(request, "")
      .pipe()
      .subscribe((data) => {
        if (data.statusCode == 0) {
          this.taxSetupRequestInfo = data.responseInfo;
          this.IsSingleRate = this.taxSetupRequestInfo?.isSingleTaxRate;
          if (this.taxSetupRequestInfo) {

            this.IsTaxRateOn = this.taxSetupRequestInfo.isTaxRateOn;
          }

          this.fnGetAllTaxRates();
        }
      });
  }
  fnGetAllTaxRates() {
    this.ukMileageRateSettingService.SoloGetAllTaxRates().pipe(first())
      .subscribe((res: IApiresponse<ITaxRateMasterResponse[]>) => {
        if (!this.IsTaxRateOn) {
          this.taxRateMasterResponse = res.responseInfo.filter(a => a.taxRate == 0);
          for (let i = 0; i < this.taxRateMasterResponse.length; i++) {
            this.taxRateMasterResponse[i].taxCode = this.taxRateMasterResponse[i].taxRate.toFixed(2) + " %";
            this.taxRateMasterResponse[i].description = this.translate.instant('self_setup_16_msg_39');
          }
        }
        else {
          this.taxRateMasterResponse = res.responseInfo;
          for (let i = 0; i < this.taxRateMasterResponse.length; i++) {
            this.taxRateMasterResponse[i].taxCode =
              this.taxRateMasterResponse[i].taxCode +
              " (" +
              this.taxRateMasterResponse[i].taxRate +
              "%)";
          }
        }


        if (!this.IsTaxRateOn) {
          //ADD Turn ON the Tax Link
          let addSetupTaxLink = {
            taxRateMasterId: 0,
            taxCode: this.translate.instant('receipt_type_text4'),
            isLink: true,
            taxRate: 0
          };

          this.taxRateMasterResponse.push(addSetupTaxLink);
        }
        else {
          //ADD Manage Tax Rates Link (opens step2 directly)
          let manageTaxLink = {
            taxRateMasterId: -1,
            taxCode: this.translate.instant('self_setup_msg_2'),
            isLink: true,
            isManageLink: true,
            taxRate: 0
          };

          this.taxRateMasterResponse.push(manageTaxLink);
        }

      });
  }
  fnGetVatRate(taxRateMasterId, isNumber) {
    if (taxRateMasterId != 0) {
      let VatRate = this.taxRateMasterResponse.filter(ss => ss.taxRateMasterId == taxRateMasterId);
      if (VatRate.length > 0) {
        this.vatRateDetail = VatRate[0];
        if (isNumber) {
          return VatRate[0].taxRate;
        }
        else {
          return VatRate[0].taxCode;
        }
      }
      return '';
    }
  }
  GetMasterVehicles() {
    this.ukMileageRateSettingService.SoloGetMasterVehicles(this.claims.RateType)
      .pipe(first()).subscribe((res: IApiresponse<IVehicleTypeMasterInfo[]>) => {
        this.vehicleTypeMasterInfoList = res.responseInfo;
        this.vehicleTypeMasterInfoList.forEach(x => x.concatVehicleTypeId = Number(String(x.vehicleTypeId) + String(x.vehicleSubTypeId)));
      });
  }

  fnGetOrgUKActiveRateByOrgMapId(orgVehicleTypeMapId) {
    let request = new ApiRequest<IRequestVehicleTypes>("GetOrgUKActiveRateByOrgMapId", environment.applicationVersion, environment.requestId);
    let requestVehicleTypes = new RequestVehicleTypes();
    requestVehicleTypes.orgVehicleTypeMapId = orgVehicleTypeMapId;
    requestVehicleTypes.rateType = this.claims.RateType;
    request.requestInfo = requestVehicleTypes;
    this.ukMileageRateSettingService.SoloGetOrgUKActiveRateByOrgMapId(request).pipe(first()).subscribe((res: IApiresponse<IOrgUKRatesByOrgMapIdResponse>) => {
      let uKMileageRateInfo = res.responseInfo;
      this.orgUKMileageRateInfo = uKMileageRateInfo.orgUKMileageRateInfoList[0];
      const ct: number = (uKMileageRateInfo as any).chargingType || 0;
      this.originalChargingType = ct;
      this.homeChargingEnabled = ct === 0 || ct === ElectricChargingType.HomeCharging || ct === ElectricChargingType.Both;
      this.thirdPartyChargingEnabled = ct === 0 || ct === ElectricChargingType.ThirdPartyCharging || ct === ElectricChargingType.Both;
      
      let vehicleTypeMasterDetail = this.vehicleTypeMasterInfoList.filter(qq => qq.vehicleTypeId == uKMileageRateInfo.vehicleTypeId)[0];
      this.fnSetOwnershipTemplateForAddRate(vehicleTypeMasterDetail);
    });
  }
  fnSetOwnershipTemplateForAddRate(item: IVehicleTypeMasterInfo) {
    this.ownershipTemplateDetail = item;
    if (this.ukMileageRateSettingConfiguration.isAddNewRate) {
      if (this.ownershipTemplateDetail.vehicleTypeId == this.vehicleTypeEnum.Private_Car || this.claims.RateType == MileageRateTypeEnum.DifferentialRate) {
        this.ukMileageRateSettingConfiguration.isOtherCarTypeSelected = false;
        this.ukMileageRateSettingConfiguration.isPrivateCarTypeSelected = true;
        this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = true;
        if (this.claims.RateType == MileageRateTypeEnum.DifferentialRate)
          this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = false;
        this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = true;
      }
      else if (this.ownershipTemplateDetail.vehicleTypeId != this.vehicleTypeEnum.Private_Car && this.claims.RateType != MileageRateTypeEnum.DifferentialRate) {
        this.ukMileageRateSettingConfiguration.isPrivateCarTypeSelected = false;
        this.ukMileageRateSettingConfiguration.isOtherCarTypeSelected = true;
        this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = false;
        this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = true;
      }
    }
    this.fnInitializeForm();
    this.fnChangeFormHeaderBasedOnUKRateConfigEnum();
    this.cdRef.detectChanges();
  }

  fnChangeFormHeaderBasedOnUKRateConfigEnum() {
    switch (this.ukMileageRateSettingConfiguration.userActionId) {
      case this.uKRateConfigEnum.ActivateOwnerShip:
        this.formData.userActionId = this.uKRateConfigEnum.ActivateOwnerShip;
        this.ukMileageRateSettingConfiguration.panelHeading = this.translate.instant("activate_ownership");
        this.ukMileageRateSettingConfiguration.isOwnershipTypeHide = true;
        this.ukMileageRateSettingConfiguration.isNewOwnershipType = false;
        this.ukMileageRateSettingConfiguration.isAddNewRate = false;
        this.ukMileageRateSettingConfiguration.isOwnershipTemplate_NameBlockhide = false;
        this.ukMileageRateSettingConfiguration.isEffictiveFromBlockhide = false;
        this.ukMileageRateSettingConfiguration.isOwnershipTemplateDisable = true;
        this.ukMileageRateSettingConfiguration.isOwnershipNameDisable = false;
        this.ukMileageRateSettingConfiguration.isSlabRateDisabled = false;
        this.ukMileageRateSettingConfiguration.isSlabVatRateDisabled = false;
        this.ukMileageRateSettingConfiguration.isCopyIconHide = true;
        if (this.formData && this.formData.highlightEditRate) {
          this.ukMileageRateSettingConfiguration.isActiveLogIconHide = true;
        }
        else {
          this.ukMileageRateSettingConfiguration.isActiveLogIconHide = false;
        }

        this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = true;
        this.ukMileageRateSettingConfiguration.isDeleteRateBtnHide = true;
        if (this.selectedOrgUKMileageVehicleTypes.vehicleTypeId == this.vehicleTypeEnum.Private_Car || this.claims.RateType == MileageRateTypeEnum.DifferentialRate) {
          this.ukMileageRateSettingConfiguration.isOtherCarTypeSelected = false;
          this.ukMileageRateSettingConfiguration.isPrivateCarTypeSelected = true;
          this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = true;
          if (this.claims.RateType == MileageRateTypeEnum.DifferentialRate)
            this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = false;
          this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = true;
        }
        else if (this.selectedOrgUKMileageVehicleTypes.vehicleTypeId != this.vehicleTypeEnum.Private_Car && this.claims.RateType != MileageRateTypeEnum.DifferentialRate) {
          this.ukMileageRateSettingConfiguration.isPrivateCarTypeSelected = false;
          this.ukMileageRateSettingConfiguration.isOtherCarTypeSelected = true;
          this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = false;
          this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = true;
        }
        if (this.selectedOrgUKMileageVehicleTypes.isDefault > 0) {
          this.ukMileageRateSettingConfiguration.isSlabRangeFromDisabled = true;
          this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled = true;
          this.ukMileageRateSettingConfiguration.isSlabDeleteRateDisabled = true;
          this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled = true;
        }
        else {
          this.ukMileageRateSettingConfiguration.isSlabRangeFromDisabled = false;
          this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled = false;
          this.ukMileageRateSettingConfiguration.isSlabDeleteRateDisabled = false;
          this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled = false;
        }
        break;
      case this.uKRateConfigEnum.ActiveRateEdit:
        this.ukMileageRateSettingConfiguration.panelHeading = this.translate.instant("edit_active_rate");
        this.ukMileageRateSettingConfiguration.isOwnershipTypeHide = true;
        this.ukMileageRateSettingConfiguration.isNewOwnershipType = false;
        this.ukMileageRateSettingConfiguration.isAddNewRate = false;
        this.ukMileageRateSettingConfiguration.isOwnershipTemplate_NameBlockhide = false;
        if (this.claims.RateType == MileageRateTypeEnum.FreeForLife) {
          this.ukMileageRateSettingConfiguration.isEffictiveFromDisabled = true;
          this.ukMileageRateSettingConfiguration.isSlabVatRateDisabled = true;
          this.ukMileageRateSettingConfiguration.isOwnershipNameDisable = true;
          this.ukMileageRateSettingConfiguration.isCostOfFuelDisable = true;
        }
        else {
          this.ukMileageRateSettingConfiguration.isEffictiveFromDisabled = false;
          this.ukMileageRateSettingConfiguration.isSlabVatRateDisabled = false;
          this.ukMileageRateSettingConfiguration.isOwnershipNameDisable = false;
          this.ukMileageRateSettingConfiguration.isCostOfFuelDisable = false;
        }

        this.ukMileageRateSettingConfiguration.isOwnershipTemplateDisable = true;
        if (this.formData && this.formData.rowData && this.formData.rowData.isExpenseCreated) {
          this.ukMileageRateSettingConfiguration.isSlabRateDisabled = true;
        }
        else {
          this.ukMileageRateSettingConfiguration.isSlabRateDisabled = false;
        }
        if (this.formData.isCopyIconHide) {
          this.ukMileageRateSettingConfiguration.isCopyIconHide = this.formData.isCopyIconHide;
          if (this.claims.RateType == MileageRateTypeEnum.FreeForLife) {
            this.ukMileageRateSettingConfiguration.isCopyIconHide = true;
          }
        }
        else {
          if (this.claims.RateType == MileageRateTypeEnum.FreeForLife) {
            this.ukMileageRateSettingConfiguration.isCopyIconHide = true;
          }
          else {
            this.ukMileageRateSettingConfiguration.isCopyIconHide = false;
          }

        }

        if (this.formData && this.formData.highlightEditRate) {
          this.ukMileageRateSettingConfiguration.isActiveLogIconHide = true;
        }
        else {
          this.ukMileageRateSettingConfiguration.isActiveLogIconHide = false;
        }
        this.ukMileageRateSettingConfiguration.isSlabRangeFromDisabled = true;
        this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled = true;
        this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled = true;
        this.ukMileageRateSettingConfiguration.isSlabDeleteRateDisabled = true;
        this.ukMileageRateSettingConfiguration.isDeleteRateBtnHide = true;
        if (this.selectedOrgUKMileageVehicleTypes.vehicleTypeId == this.vehicleTypeEnum.Private_Car || this.claims.RateType == MileageRateTypeEnum.DifferentialRate) {
          this.ukMileageRateSettingConfiguration.isOtherCarTypeSelected = false;
          this.ukMileageRateSettingConfiguration.isPrivateCarTypeSelected = true;
          this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = true;
          if (this.claims.RateType == MileageRateTypeEnum.DifferentialRate)
            this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = false;
          this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = true;
        }
        else if (this.selectedOrgUKMileageVehicleTypes.vehicleTypeId != this.vehicleTypeEnum.Private_Car && this.claims.RateType != MileageRateTypeEnum.DifferentialRate) {
          this.ukMileageRateSettingConfiguration.isPrivateCarTypeSelected = false;
          this.ukMileageRateSettingConfiguration.isOtherCarTypeSelected = true;
          this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = false;
          this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = true;
        }
        break;
      case this.uKRateConfigEnum.AddNewOwnership:
        this.ukMileageRateSettingConfiguration.panelHeading = this.translate.instant("add_new_ownership");
        this.ukMileageRateSettingConfiguration.isOwnershipTypeHide = true;
        this.ukMileageRateSettingConfiguration.isAddNewRate = false;
        this.ukMileageRateSettingConfiguration.isOwnershipTemplate_NameBlockhide = false;
        this.ukMileageRateSettingConfiguration.isOwnershipTemplateDisable = false;
        this.ukMileageRateSettingConfiguration.isOwnershipNameDisable = false;
        this.ukMileageRateSettingConfiguration.isSlabRateDisabled = false;
        this.ukMileageRateSettingConfiguration.isSlabVatRateDisabled = false;
        this.ukMileageRateSettingConfiguration.isSlabDeleteRateDisabled = false;
        this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled = false;
        this.ukMileageRateSettingConfiguration.isSlabRangeFromDisabled = true;
        this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled = false;
        this.ukMileageRateSettingConfiguration.isCopyIconHide = true;
        if (this.formData && this.formData.highlightEditRate) {
          this.ukMileageRateSettingConfiguration.isActiveLogIconHide = true;
        }
        else {
          this.ukMileageRateSettingConfiguration.isActiveLogIconHide = false;
        }
        this.ukMileageRateSettingConfiguration.isDeleteRateBtnHide = true;
        break;
      case this.uKRateConfigEnum.AddNewRate:
        this.ukMileageRateSettingConfiguration.isAddNewRate = true;
        this.ukMileageRateSettingConfiguration.isSlabRateDisabled = false;
        this.ukMileageRateSettingConfiguration.isSlabVatRateDisabled = false;
        this.ukMileageRateSettingConfiguration.isOwnershipTypeDisabled = false;
        this.ukMileageRateSettingConfiguration.isCopyIconHide = true;
        this.ukMileageRateSettingConfiguration.isActiveLogIconHide = true;
        this.ukMileageRateSettingConfiguration.isOwnershipTemplate_NameBlockhide = false;
        this.ukMileageRateSettingConfiguration.isEffictiveFromBlockhide = false;
        this.ukMileageRateSettingConfiguration.isDeleteRateBtnHide = true;
        if (this.vehicleTypeDetail.isDefault > 0) {
          this.ukMileageRateSettingConfiguration.isSlabRangeFromDisabled = true;
          this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled = true;
          this.ukMileageRateSettingConfiguration.isSlabDeleteRateDisabled = true;
          this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled = true;
        }
        else {
          this.ukMileageRateSettingConfiguration.isSlabRangeFromDisabled = false;
          this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled = false;
          this.ukMileageRateSettingConfiguration.isSlabDeleteRateDisabled = false;
          this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled = false;
        }
        //this.fnSetCalendar(null);
        break;
      case this.uKRateConfigEnum.CopyRate:
        this.ukMileageRateSettingConfiguration.panelHeading = this.translate.instant("copy_rate");
        this.ukMileageRateSettingConfiguration.isCostOfFuelDisable = false;
        this.ukMileageRateSettingConfiguration.isOwnershipTypeHide = true;
        this.ukMileageRateSettingConfiguration.isNewOwnershipType = false;
        this.ukMileageRateSettingConfiguration.isAddNewRate = false;
        this.ukMileageRateSettingConfiguration.isOwnershipTemplate_NameBlockhide = false;
        this.ukMileageRateSettingConfiguration.isEffictiveFromBlockhide = false;
        this.ukMileageRateSettingConfiguration.isOwnershipTemplateDisable = true;
        this.ukMileageRateSettingConfiguration.isSlabRateDisabled = false;
        this.ukMileageRateSettingConfiguration.isSlabVatRateDisabled = false;
        this.ukMileageRateSettingConfiguration.isCopyIconHide = true;
        this.ukMileageRateSettingConfiguration.isActiveLogIconHide = true;
        this.ukMileageRateSettingConfiguration.isOwnershipTypeDisabled = true;
        this.ukMileageRateSettingConfiguration.isDeleteRateBtnHide = true;
        if (this.selectedOrgUKMileageVehicleTypes.isDefault > 0) {
          this.ukMileageRateSettingConfiguration.isSlabRangeFromDisabled = true;
          this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled = true;
          this.ukMileageRateSettingConfiguration.isSlabDeleteRateDisabled = true;
          this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled = true;
        }
        else {
          this.ukMileageRateSettingConfiguration.isSlabRangeFromDisabled = false;
          this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled = false;
          this.ukMileageRateSettingConfiguration.isSlabDeleteRateDisabled = false;
          this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled = false;
        }
        //this.fnSetCalendar(null);
        break;
      case this.uKRateConfigEnum.FutureRateEdit:
        this.ukMileageRateSettingConfiguration.panelHeading = this.translate.instant("edit_future_rate");
        this.ukMileageRateSettingConfiguration.isOwnershipTypeHide = true;
        this.ukMileageRateSettingConfiguration.isNewOwnershipType = false;
        this.ukMileageRateSettingConfiguration.isAddNewRate = false;
        this.ukMileageRateSettingConfiguration.isOwnershipTemplate_NameBlockhide = false;
        this.ukMileageRateSettingConfiguration.isEffictiveFromBlockhide = false;
        this.ukMileageRateSettingConfiguration.isOwnershipTemplateDisable = true;
        this.ukMileageRateSettingConfiguration.isSlabRateDisabled = false;
        this.ukMileageRateSettingConfiguration.isSlabVatRateDisabled = false;
        this.ukMileageRateSettingConfiguration.isCopyIconHide = false;
        this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = true;
        this.ukMileageRateSettingConfiguration.isActiveLogIconHide = true;
        this.ukMileageRateSettingConfiguration.isDeleteRateBtnHide = false;
        if (this.selectedOrgUKMileageVehicleTypes.vehicleTypeId == this.vehicleTypeEnum.Private_Car || this.claims.RateType == MileageRateTypeEnum.DifferentialRate) {
          this.ukMileageRateSettingConfiguration.isOtherCarTypeSelected = false;
          this.ukMileageRateSettingConfiguration.isPrivateCarTypeSelected = true;
          this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = true;
          if (this.claims.RateType == MileageRateTypeEnum.DifferentialRate)
            this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = false;
          this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = true;
        }
        else if (this.selectedOrgUKMileageVehicleTypes.vehicleTypeId != this.vehicleTypeEnum.Private_Car && this.claims.RateType != MileageRateTypeEnum.DifferentialRate) {
          this.ukMileageRateSettingConfiguration.isPrivateCarTypeSelected = false;
          this.ukMileageRateSettingConfiguration.isOtherCarTypeSelected = true;
          this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = false;
          this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = true;
        }
        if (this.selectedOrgUKMileageVehicleTypes.isDefault > 0) {
          this.ukMileageRateSettingConfiguration.isSlabRangeFromDisabled = true;
          this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled = true;
          this.ukMileageRateSettingConfiguration.isSlabDeleteRateDisabled = true;
          this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled = true;
        }
        else {
          this.ukMileageRateSettingConfiguration.isSlabRangeFromDisabled = false;
          this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled = false;
          this.ukMileageRateSettingConfiguration.isSlabDeleteRateDisabled = false;
          this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled = false;
        }
        //this.fnSetCalendar(null);
        break;
    }
    this.ukMileageRateSettingConfiguration.isOverlayEnabled = true;
  }
  get mileageMultiRateInfoListArray() {
    return this.formctrl.get('mileageMultiRateInfoList') as UntypedFormArray;
  }

  get isElectricCar(): boolean {
    if (this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewOwnership) {
      return this.ownershipTemplateDetail?.vehicleSubTypeId === this.vehicleSubTypeEnum.ElectricHome_3rdParty;
    }
    if (this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewRate) {
      return this.vehicleTypeDetail?.vehicleSubTypeId === this.vehicleSubTypeEnum.ElectricHome_3rdParty;
    }
    return this.selectedOrgUKMileageVehicleTypes?.vehicleSubTypeId === this.vehicleSubTypeEnum.ElectricHome_3rdParty;
  }

  fnGetElectricChargingType(): number {
    if (this.homeChargingEnabled && this.thirdPartyChargingEnabled) return 3;
    if (this.homeChargingEnabled) return 1;
    if (this.thirdPartyChargingEnabled) return 2;
    return 0;
  }

  addMileageMultiRateInfo() {
    let minMileageRate = 0.01;
    if (this.claims.RateType == MileageRateTypeEnum.DifferentialRate) {
      minMileageRate = 0;
    }
    this.mileageMultiRateInfoListArray.push(this.BuildFormDynamic(new MileageMultiRateInfo(), minMileageRate));
    this.fnCalculateRangeForPrivateCar();
    this.ukMileageRateSettingConfiguration.submitted = false;
  }
  deleteMileageMultiRateInfoFromList(index) {
    this.mileageMultiRateInfoListArray.removeAt(index);
    this.fnCalculateRangeForPrivateCar();
  }
  fnCalculateRangeForPrivateCar() {
    let prevRangeTo = 0;
    let isAnyError = false;
    for (let index = 0; index < this.mileageMultiRateInfoListArray.value.length; index++) {
      if (index > 0) {
        prevRangeTo = parseFloat(this.mileageMultiRateInfoListArray.at(index - 1).get('rangeTo').value);
        this.mileageMultiRateInfoListArray.at(index).get('rangeFrom').setValue(prevRangeTo + 0.001);
        let rangeFrom = parseFloat(this.mileageMultiRateInfoListArray.at(index).get('rangeFrom').value);
        let rangeTo = parseFloat(this.mileageMultiRateInfoListArray.at(index).get('rangeTo').value);
        if (rangeFrom > rangeTo) {
          this.mileageMultiRateInfoListArray.at(index).get('isRangeToInvalid').setValue(true);
          this.ukMileageRateSettingConfiguration.isRangeToValidationDisplay = true;
          isAnyError = true;
        }
        else {
          this.mileageMultiRateInfoListArray.at(index).get('isRangeToInvalid').setValue(false);
        }
      }
    }
    if (!isAnyError) {
      this.ukMileageRateSettingConfiguration.isRangeToValidationDisplay = false;
    }
  }
  fnChangeVateRateInArray(index, ev) {
    let vatRateId = ev.target.value;
    let taxRate = this.taxRateMasterResponse.filter(aa => aa.taxRateMasterId == vatRateId)[0].taxRate;
    this.mileageMultiRateInfoListArray.at(index).get('vatRate').setValue(taxRate);
  }
  setMaxFuelRate(value) {
    if (this.isElectricCar) {
      return;
    }
    if (this.claims.RateType != MileageRateTypeEnum.FreeForLife) {
      if (this.ukMileageRateSettingConfiguration.isPrivateCarTypeSelected) {
        let maxRate = 0.0;
        for (let index = 0; index < this.formctrl.value.mileageMultiRateInfoList.length; index++) {
          let newMileageRate = parseFloat(this.formctrl.value.mileageMultiRateInfoList[index].mileageRate);
          if (newMileageRate > maxRate) {
            maxRate = newMileageRate;
          }
        }
        this.maxFuelRate = maxRate;
      }
      else {
        this.maxFuelRate = parseFloat(this.formctrl.value.mileageRate);
      }

      let nrFuleRate = parseFloat(this.formctrl.value.nrFuelRate);
      if ((nrFuleRate == 0 && this.claims.RateType == MileageRateTypeEnum.DifferentialRate) || this.isFCassignedToOwnership) {
        this.formctrl.controls.mileageRate.setValidators(null);
        this.formctrl.controls.mileageRate.updateValueAndValidity();

        for (let index = 0; index < this.mileageMultiRateInfoListArray.value.length; index++) {
          this.mileageMultiRateInfoListArray.at(index).get('mileageRate').clearValidators();
          this.mileageMultiRateInfoListArray.at(index).get('mileageRate').setErrors(null);
        }
        this.formctrl.controls.nrFuelRate.setValidators(null);
        this.formctrl.controls.nrFuelRate.updateValueAndValidity();
        this.formctrl.controls.nrFuelRate.setErrors(null);
        this.cdRef.detectChanges();
      }
      else {
        if (nrFuleRate > this.maxFuelRate) {
          this.formctrl.controls.nrFuelRate.setErrors({ 'max': { max: this.maxFuelRate, actual: nrFuleRate } });
          this.cdRef.detectChanges();
        }
        else {
          if (nrFuleRate > 0) {
            this.formctrl.controls.nrFuelRate.setErrors(null);
            this.cdRef.detectChanges();
          }
          else {
            if (this.claims.RateType != MileageRateTypeEnum.FreeForLife) {
              if (nrFuleRate == 0) {
                this.formctrl.controls.nrFuelRate.setErrors({ 'cannotBeZero': true });
              }
              else {
                this.formctrl.controls.nrFuelRate.setErrors({ 'required': true });
              }
              this.cdRef.detectChanges();
            }
          }
        }
      }
    }
    else {
      this.formctrl.controls.nrFuelRate.setErrors(null);
      this.cdRef.detectChanges();
    }
    setTimeout(() => {
      this.cdRef.detectChanges();
    }, 200);

  }

  onSubmit() {
    if (this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.ActiveRateEdit
      && this.ukMileageRateSettingConfiguration.isActivateValidationDisplay) {
      this.ShowOwnershipAlertPanel();
      return;
    }
    this.ukMileageRateSettingConfiguration.submitted = true;
    if (this.isElectricCar && !this.fnValidateElectricCarRates()) {
      return;
    }
    let validateOwnershipNameApiRequest = new ApiRequest<ValidateOwnershipNameRequest>("SaveUKMileageRate", environment.applicationVersion, environment.requestId);
    let validateOwnershipNameRequest = new ValidateOwnershipNameRequest();
    if (this.ukMileageRateSettingConfiguration.isNewOwnershipType
      && this.ownershipTemplateDetail.vehicleTypeId == this.vehicleTypeEnum.Company_Car
      && !this.isElectricCar) {
      for (let index = 0; index < this.mileageMultiRateInfoListArray.value.length; index++) {
        this.mileageMultiRateInfoListArray.at(index).get('mileageRate').clearValidators();
        this.mileageMultiRateInfoListArray.at(index).get('mileageRate').setErrors(null);
      }
    }
    if (this.formctrl.invalid) {
      return;
    }
    else {
      if (this.formData?.rowData?.uniqueRowId > 0) {

        this.formData.rowData.effectiveFrom = this.datepipe.transform(this.formctrl.value.effectiveFrom, 'MM/dd/yyyy');

        this.formData.rowData.nrFuelRate = this.formctrl.value.nrFuelRate;
        this.formData.rowData.mileageRate = this.formctrl.value.mileageRate;

        this.formData.rowData.vatRate = this.vatRateDetail?.taxRate;
        this.formData.rowData.vatRateName = this.vatRateDetail?.taxCode;
        this.formData.rowData.vatRateId = this.vatRateDetail?.taxRateMasterId;
        this.formData.rowData.mileageMultiRateInfoList = this.formctrl.value.mileageMultiRateInfoList;

        this.ukMileageRateSettingConfiguration.submitted = false;
        this.vatRateDetail = null;
        this.ukMileageRateSettingConfiguration.vatRateModel = '';
        this.resetForm(null, null);
        this.ukMileageRateSettingConfiguration.isOverlayEnabled = false;
        this.ukMileageRateSettingConfiguration.isAddNewRate = false;
        this.ukMileageRateSettingConfiguration.isOwnershipNameDuplicate = false;
        this.ukMileageRateSettingConfiguration.isRangeToValidationDisplay = false;
        this.closePanelRateImport.emit(this.formData.rowData);
        return;
      }

      let nrFuelRate = this.formctrl.value.nrFuelRate ? parseFloat(this.formctrl.value.nrFuelRate) : 0;
      if (!this.isElectricCar && (this.claims.RateType != MileageRateTypeEnum.FreeForLife && nrFuelRate == 0)) {
        if (!((nrFuelRate == 0 && this.claims.RateType == MileageRateTypeEnum.DifferentialRate)
          || this.isFCassignedToOwnership)) {
          this.formctrl.controls.nrFuelRate.setErrors({ 'required': true });
          this.cdRef.detectChanges();
          return;
        }
        else {
          if (!nrFuelRate) {
            this.formctrl.patchValue({
              nrFuelRate: 0.0
            });
          }
          if (!nrFuelRate) {
            this.formctrl.patchValue({
              mileageRate: 0.0
            });
          }
          this.cdRef.detectChanges();
        }

      }
    }

    let apiRequest = new ApiRequest<SaveOwnershiptypeRequest>("SaveUKMileageRate", environment.applicationVersion, environment.requestId);
    let requestInfo = new SaveOwnershiptypeRequest();
    requestInfo.ownershiptypeList = [];
    let request = new UkRateInfo();
    request.vehicleLabel = this.formctrl.value.vehicleLabel;
    if (this.formctrl.value.effectiveFrom == null) {
      let gmtDate = (new Date(UTCDateTime.getUTCDate(new Date()))).toISOString();
      request.effectiveFrom = gmtDate;
    }
    else {
      let tempDate = new Date(this.datepipe.transform(this.formctrl.value.effectiveFrom, 'MM/dd/yyyy'));

      let gmtEffDate = (new Date(UTCDateTime.getUTCTimeStamp(tempDate))).toISOString()
      request.effectiveFrom = gmtEffDate;
    }
    request.mileageMultiRateInfoList = this.formctrl.value.mileageMultiRateInfoList;

    // Ensure each rate row has complete VAT data; fill missing fields from taxRateMasterResponse
    request.mileageMultiRateInfoList.forEach(element => {
      if (element.vatRateId && this.taxRateMasterResponse?.length) {
        const taxEntry = this.taxRateMasterResponse.find(t => t.taxRateMasterId == element.vatRateId);
        if (taxEntry) {
          if (element.vatRate == null || element.vatRate == undefined || element.vatRate === '') { element.vatRate = taxEntry.taxRate; }
          if (!element.vatRateName || element.vatRateName.trim() === '') { element.vatRateName = taxEntry.taxCode; }
        }
      }
    });

    request.actionId = this.ukMileageRateSettingConfiguration.userActionId;
    request.rateType = this.claims.RateType;
    request.nrFuelRate = this.formctrl.value.nrFuelRate ? this.formctrl.value.nrFuelRate : 0;
    if (this.isElectricCar) {
      request.chargingType = this.fnGetElectricChargingType();
    }
    validateOwnershipNameRequest.rateType = this.claims.RateType;
    if (this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewRate) {
      request.orgVehicleTypeMapId = this.vehicleTypeDetail.orgVehicleTypeMapId;
    }
    else {
      if (this.ukMileageRateSettingConfiguration.userActionId != this.uKRateConfigEnum.AddNewOwnership) { request.orgVehicleTypeMapId = this.selectedOrgUKMileageVehicleTypes.orgVehicleTypeMapId; }
    }
    if (this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewOwnership) {
      request.vehicleTypeId = this.ownershipTemplateDetail.vehicleTypeId;
      request.orgVehicleTypeMapId = 0;
      request.vehicleSubTypeId = this.ownershipTemplateDetail.vehicleSubTypeId;
      request.baseName = this.ownershipTemplateDetail.baseName;
      request.vehicleTypeName = this.ownershipTemplateDetail.vehicleTypeName;
      request.vehicleSubTypeName = this.ownershipTemplateDetail.vehicleSubTypeName;
      request.sequence = this.ownershipTemplateDetail.sequence;
      request.isMultiRange = this.ownershipTemplateDetail.isMultiRange;
      if (this.ownershipTemplateDetail.vehicleTypeId != this.vehicleTypeEnum.Private_Car && this.claims.RateType != MileageRateTypeEnum.DifferentialRate && !this.isElectricCar) {
        if (this.vatRateDetail != undefined || this.vatRateDetail != null) {
          request.mileageMultiRateInfoList[0].vatRate = this.vatRateDetail.taxRate;
          request.mileageMultiRateInfoList[0].vatRateName = this.vatRateDetail.taxCode;
          request.mileageMultiRateInfoList[0].vatRateId = this.vatRateDetail.taxRateMasterId;
          request.mileageMultiRateInfoList[0].nrFuelRate = this.formctrl.value.nrFuelRate ? this.formctrl.value.nrFuelRate : 0;
        }
      }
      if (this.ownershipTemplateDetail.vehicleTypeId == this.vehicleTypeEnum.Company_Car) {
        validateOwnershipNameRequest.ownershipName = this.ownershipTemplateDetail.baseName + "-" + this.formctrl.value.vehicleLabel;
      }
      else {
        validateOwnershipNameRequest.ownershipName = this.formctrl.value.vehicleLabel;
      }
    }
    else {
      if (this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewRate) {
        request.vehicleTypeId = this.vehicleTypeDetail.vehicleTypeId;
        if (this.vehicleTypeDetail.vehicleTypeId == this.vehicleTypeEnum.Company_Car) {
          validateOwnershipNameRequest.ownershipName = this.vehicleTypeDetail.derivedName + "-" + this.formctrl.value.vehicleLabel;
        }
        else {
          validateOwnershipNameRequest.ownershipName = this.formctrl.value.vehicleLabel;
        }
      }
      else {
        if (this.selectedOrgUKMileageVehicleTypes.vehicleTypeId == this.vehicleTypeEnum.Company_Car) {
          validateOwnershipNameRequest.ownershipName = this.selectedOrgUKMileageVehicleTypes.derivedName + "-" + this.formctrl.value.vehicleLabel;
        }
        else {
          validateOwnershipNameRequest.ownershipName = this.formctrl.value.vehicleLabel;
        }
        request.vehicleTypeId = this.selectedOrgUKMileageVehicleTypes.vehicleTypeId;
      }
      if (request.vehicleTypeId != this.vehicleTypeEnum.Private_Car && this.claims.RateType != MileageRateTypeEnum.DifferentialRate && !this.isElectricCar) {
        if (this.vatRateDetail != undefined || this.vatRateDetail != null) {
          request.mileageMultiRateInfoList[0].vatRate = this.vatRateDetail.taxRate;
          request.mileageMultiRateInfoList[0].vatRateName = this.vatRateDetail.taxCode;
          request.mileageMultiRateInfoList[0].vatRateId = this.vatRateDetail.taxRateMasterId;
          request.mileageMultiRateInfoList[0].nrFuelRate = this.formctrl.value.nrFuelRate ? this.formctrl.value.nrFuelRate : 0;
        }
      }
    }
    let rangeTo = 0;
    let rangeFrom = 0;
    if (!this.isElectricCar && (request.vehicleTypeId == this.vehicleTypeEnum.Private_Car || this.claims.RateType == MileageRateTypeEnum.DifferentialRate)) {
      let isAnyError = false;
      for (let index = 0; index < this.mileageMultiRateInfoListArray.value.length; index++) {
        if (index > 0) {
          rangeFrom = parseFloat(this.mileageMultiRateInfoListArray.at(index).get('rangeFrom').value);
          rangeTo = parseFloat(this.mileageMultiRateInfoListArray.at(index).get('rangeTo').value);
          if (rangeFrom > rangeTo) {
            this.mileageMultiRateInfoListArray.at(index).get('isRangeToInvalid').setValue(true);
            this.ukMileageRateSettingConfiguration.isRangeToValidationDisplay = true;
            isAnyError = true;
          }
          else {
            this.mileageMultiRateInfoListArray.at(index).get('isRangeToInvalid').setValue(false);
          }
        }
      }
      if (this.ukMileageRateSettingConfiguration.isRangeToValidationDisplay) {
        return;
      }
      if (!isAnyError) {
        this.ukMileageRateSettingConfiguration.isRangeToValidationDisplay = false;
      }
    }
    request.mileageMultiRateInfoList.forEach((element, index) => {
      if (!this.isElectricCar) {
        element.nrFuelRate = this.formctrl.value.nrFuelRate ? this.formctrl.value.nrFuelRate : 0;
      }
      if (this.isElectricCar) {
        // Explicitly set chargingType per Electric Car row: use form control value or fall back to index position (Home=1, ThirdParty=2)
        const formChargingType = this.mileageMultiRateInfoListArray.at(index).get('chargingType')?.value;
        element.chargingType = formChargingType || (index === 0 ? 1 : 2);
        // Each electric car card has its own vatRateId in the form � resolve vatRate/vatRateName per element
        const vatRateEntry = this.taxRateMasterResponse.find(r => r.taxRateMasterId === element.vatRateId);
        if (vatRateEntry) {
          element.vatRate = vatRateEntry.taxRate;
          element.vatRateName = vatRateEntry.taxCode;
        }
      } else if (this.vatRateDetail) {
        element.vatRate = this.vatRateDetail.taxRate;
        element.vatRateName = this.vatRateDetail.taxCode;
        element.vatRateId = this.vatRateDetail.taxRateMasterId;
      }
      if (!this.isElectricCar && request.vehicleTypeId != this.vehicleTypeEnum.Private_Car
        && request.rateType != this.mileageRateTypeEnum.DifferentialRate) {
        element.mileageRate = this.formctrl.value.mileageRate ? this.formctrl.value.mileageRate : 0;
      }
      if (!this.isElectricCar) {
        let arrayMileageRate = request.mileageMultiRateInfoList.map(function (obj) {
          return obj.mileageRate;
        });
        let maxMileage = Math.max(...arrayMileageRate);
        if (!this.isFCassignedToOwnership && Number(element.nrFuelRate) > Number(maxMileage)) {
          element.nrFuelRate = Math.max(...arrayMileageRate);
        }
      }
    });
    if (this.formctrl.value.isActive != null) {
      request.isActive = this.formctrl.value.isActive;
      this.isActive = this.formctrl.value.isActive;
    }
    if (this.isElectricCar && request.chargingType !== this.originalChargingType) {
      requestInfo.deleteActivationRequest = true;
    }
    requestInfo.ownershiptypeList.push(request);
    apiRequest.requestInfo = requestInfo;

    validateOwnershipNameApiRequest.requestInfo = validateOwnershipNameRequest;
    if (this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.ActivateOwnerShip
      || this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.ActiveRateEdit
      || this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewRate
      || this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.FutureRateEdit
      || this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.CopyRate) {
      let oldVehicleLabel = this.formData.rowData ? this.formData.rowData.vehicleLabel.toLowerCase().trim() : '';
      let newVehicleLabel = request.vehicleLabel.toLowerCase().trim();
      if (this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewRate
        || oldVehicleLabel == newVehicleLabel) {
        this.ukMileageRateSettingService.SoloSaveUKMileageRate(apiRequest).subscribe((res: IApiresponse<ISaveOrgMileageWizardResponse>) => {
          if (res.statusCode == 0) {
            this.toastr.success(this.translate.instant("success"));
            this.isFCassignedToOwnership = false;
            if (this.isPassengerLoadPurchased
              && this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.ActivateOwnerShip) {
              this.fnGetAlertValidationForPassengerLoad();
              setTimeout(() => {
                this.fnCloseForm(PanelClosActionEnum.Save, true, true);
                this.cdRef.detectChanges();
              }, 50);

            }
            else {
              this.fnCloseForm(PanelClosActionEnum.Save, true, true);
              this.cdRef.detectChanges();
            }
          }
        });
      }
      else {
        this.ukMileageRateSettingService.SoloValidateOwnerhipName(validateOwnershipNameApiRequest).pipe(first()).subscribe((res: IApiresponse<any>) => {
          if (res.statusCode == 0) {
            let isOwnershipNameNotExist = res.responseInfo.isOwnershipNameExist;
            if (isOwnershipNameNotExist) {
              this.ukMileageRateSettingService.SoloSaveUKMileageRate(apiRequest).pipe(first()).subscribe((res: IApiresponse<ISaveOrgMileageWizardResponse>) => {
                if (res.statusCode == 0) {
                  this.toastr.success(this.translate.instant("success"));
                  if (this.isPassengerLoadPurchased
                    && this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.ActivateOwnerShip) {
                    this.fnGetAlertValidationForPassengerLoad();
                    setTimeout(() => {
                      this.fnCloseForm(PanelClosActionEnum.Save, true, true);
                      this.cdRef.detectChanges();
                    }, 50);
                  }
                  else {
                    this.fnCloseForm(PanelClosActionEnum.Save, true, true);
                    this.cdRef.detectChanges();
                  }
                }
              });
            }
            else {
              this.ukMileageRateSettingConfiguration.isOwnershipNameDuplicate = true;
            }
          }
        });
      }
    }
    else {
      this.ukMileageRateSettingService.SoloValidateOwnerhipName(validateOwnershipNameApiRequest).pipe(first()).subscribe((res: IApiresponse<any>) => {
        if (res.statusCode == 0) {
          let isOwnershipNameNotExist = res.responseInfo.isOwnershipNameExist;
          if (isOwnershipNameNotExist) {
            this.ukMileageRateSettingService.SoloSaveUKMileageRate(apiRequest).pipe(first()).subscribe((res: IApiresponse<ISaveOrgMileageWizardResponse>) => {
              if (res.statusCode == 0) {
                this.toastr.success(this.translate.instant("success"));
                this.fnCloseForm(PanelClosActionEnum.Save, true, true);
                let isPageRefresh = false;
                if (!this.selectedOrgUKMileageVehicleTypes
                  && this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewOwnership) {
                  isPageRefresh = true;
                }
              }
            });
          }
          else {
            this.ukMileageRateSettingConfiguration.isOwnershipNameDuplicate = true;
          }
        }
      });
    }
  }

  fnGetAlertValidationForPassengerLoad() {
    if (this.isPassengerLoadPurchased && this.passengerLoadDisplay && this.claims?.IsPassengerLoadOn) {
      this.ukMileageRateSettingConfiguration.userActionId = this.uKRateConfigEnum.ActivateOwnerShip;
    }

  }

  fnValidateEffectiveDate(event) {
    let oldDateValue = this.formctrl.get('effectiveFrom').value;
    let apiRequest = new ApiRequest<IValidateEffectiveDateRequest>("ValidateEffectiveDate", environment.applicationVersion, environment.requestId);
    let newDate = new Date(event.target.value);
    let dateFilter = new Date(Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate(), 0, 0, 0, 0)).toUTCString();
    let request = new ValidateEffectiveDateRequest(this.formctrl.value.orgVehicleTypeMapId, dateFilter);
    request.rateType = this.claims.RateType;
    apiRequest.requestInfo = request;
    this.ukMileageRateSettingService.SoloValidateEffectiveDate(apiRequest).pipe(first()).subscribe((res: IApiresponse<boolean>) => {
      let isValidate = res.responseInfo;
      this.cdRef.detectChanges();
      if (!isValidate) {
        this.fnOpenAlertWithMessages();
        this.ukMileageRateSettingConfiguration.isEffectiveFromValidation = true;
        this.formctrl.patchValue({
          effectiveFrom: oldDateValue
        });
        this.cdRef.detectChanges();
        this.fnSetCalendar(this.orgUKMileageRateInfo.effectiveFrom);
      }
      else {
        if (this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.ActiveRateEdit) {
          let OldDate = formatDate(oldDateValue, 'dd-MMM-yyyy', 'en-US');
          let OldDateFormat = new Date(OldDate);
          let newDate = new Date(event.target.value);
          let todayDateShort = formatDate(new Date(), 'dd-MMM-yyyy', 'en-US');
          let todayDateFormat = new Date(todayDateShort);
          if (OldDateFormat < newDate && newDate > todayDateFormat) {
            this.ukMileageRateSettingConfiguration.userActionId = this.uKRateConfigEnum.CopyRate;
            this.fnChangeFormHeaderBasedOnUKRateConfigEnum();
            this.cdRef.detectChanges();
          }

        }
      }
    });
  }
  fncloseEffictiveValidation() {
    this.ukMileageRateSettingConfiguration.isEffectiveFromValidation = false;
  }
  fnAddRate() {
    this.resetForm(null, null);
    this.ukMileageRateSettingConfiguration.isAddNewRate = true;
    this.ukMileageRateSettingConfiguration.userActionId = this.uKRateConfigEnum.AddNewRate;
    this.ukMileageRateSettingConfiguration.isOverlayEnabled = true;
    this.ukMileageRateSettingConfiguration.isOwnershipTemplateDisable = true;
    this.ukMileageRateSettingConfiguration.panelHeading = this.translate.instant("uk_mileage_add_new_rate");
    this.ukMileageRateSettingConfiguration.isOwnershipTypeHide = false;
    this.ukMileageRateSettingConfiguration.isOwnershipTemplate_NameBlockhide = true;
    this.ukMileageRateSettingConfiguration.isEffictiveFromBlockhide = true;
    this.ukMileageRateSettingConfiguration.isActiveLogIconHide = true;
    this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = false;
    this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = false;
  }
  resetForm(concatVehicleTypeId: any, vehicleTypeId, preserveToggleSetting: boolean = false) {
    this.orgUKMileageRateInfo = new OrgOwnershipTypeInfo();
    let rateList = [];
    let rateListForm = [];
    let rate = new MileageMultiRateInfo();
    rate.rangeFrom = 0;
    if (this.orgUKRateSelectedVehiclesResponse != null) {
      if (this.claims.RateType == MileageRateTypeEnum.DifferentialRate)
        rate.rangeTo = 50;
    }
    rateList.push(rate);
    if (vehicleTypeId && this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewOwnership
      && vehicleTypeId == this.vehicleTypeEnum.Private_Car && !this.isElectricCar) {
      let rate2 = new MileageMultiRateInfo();
      rate2.rangeFrom = 10000.001;
      rate2.rangeTo = 99999;
      rateList.push(rate2);
    }
    if (this.ownershipTemplateDetail?.vehicleSubTypeId === this.vehicleSubTypeEnum.ElectricHome_3rdParty
      && this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewOwnership) {
      rateList = [];
      const rateHome = new MileageMultiRateInfo();
      rateHome.chargingType = 1;
      const rate3Party = new MileageMultiRateInfo();
      rate3Party.chargingType = 2;
      rateList.push(rateHome);
      rateList.push(rate3Party);
      this.homeChargingEnabled = true;
      this.thirdPartyChargingEnabled = true;
    }

    let minMileageRate = 0.01;
    this.orgUKMileageRateInfo.mileageMultiRateInfoList = rateList;
    for (let i = 0; i < this.orgUKMileageRateInfo.mileageMultiRateInfoList.length; i++) {
      if (this.claims.RateType == this.mileageRateTypeEnum.DifferentialRate && i > 0) {
        minMileageRate = 0;
      }
      rateListForm.push(this.BuildFormDynamic(this.orgUKMileageRateInfo.mileageMultiRateInfoList[i], minMileageRate));
    }

    this.formctrl = this.fb.group({
      effectiveFrom: ['', [Validators.required]],
      nrFuelRate: [0.001, [Validators.required]],
      derivedName: [null],
      orgVehicleTypeMapId: [0],
      vehicleSubTypeId: [null],
      concatVehicleTypeId: [concatVehicleTypeId],
      vehicleLabel: ['', [Validators.required]],
      resetDate: this.datepipe.transform(this.PanelData?.currentFinancialYear, 'dd-MMM'),
      isActive: preserveToggleSetting ? this.formctrl.value.isActive : [false],
      mileageMultiRateInfoList: this.fb.array(rateListForm),
      vatRate: [0],
      vatRateId: [0],
      mileageRate: [0, [Validators.required]],
    });
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.formctrl.controls.nrFuelRate.setErrors(null);
      this.cdRef.detectChanges();
    }, 20);

  }
  fnAddOwnershipType() {
    this.ukMileageRateSettingConfiguration.userActionId = this.uKRateConfigEnum.AddNewOwnership;
    this.resetForm(null, null);
    this.ukMileageRateSettingConfiguration.isNewOwnershipType = true;
    this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = false;
    this.ukMileageRateSettingConfiguration.isOverlayEnabled = true;
    this.ukMileageRateSettingConfiguration.isEffictiveFromBlockhide = true;
    this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = false;
    this.fnChangeFormHeaderBasedOnUKRateConfigEnum();
  }

  fnSetVehicleTypeValue(item: IOrgUKMileageVehicleTypes) {
    this.vehicleTypeDetail = item;
    this.vehicleTypeDetail.concatVehicleTypeId = Number(String(item.vehicleTypeId) + String(item.vehicleSubTypeId));

    this.resetForm(null, null);
    this.ukMileageRateSettingConfiguration.isVehicleTypeDropdown = false;
    this.fnGetOrgUKActiveRateByOrgMapId(this.vehicleTypeDetail.orgVehicleTypeMapId);
    this.ukMileageRateSettingConfiguration.isOwnershipTemplate_NameBlockhide = false;
    this.ukMileageRateSettingConfiguration.isEffictiveFromBlockhide = false;
    setTimeout(() => {
      this.formctrl.markAsDirty();
      this.cdRef.detectChanges();
    }, 500);

    this.cdRef.detectChanges();
  }

  fnSetOwnershipTemplateValue(item: IVehicleTypeMasterInfo) {
    this.ukMileageRateSettingConfiguration.isEffictiveFromBlockhide = false;
    this.ownershipTemplateDetail = item;

    if (this.ukMileageRateSettingConfiguration.isNewOwnershipType) {
      if (this.ownershipTemplateDetail.vehicleTypeId == this.vehicleTypeEnum.Private_Car || this.claims.RateType == MileageRateTypeEnum.DifferentialRate) {
        this.ukMileageRateSettingConfiguration.isOtherCarTypeSelected = false;
        this.ukMileageRateSettingConfiguration.isPrivateCarTypeSelected = true;
        this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = true;
        if (this.claims.RateType == MileageRateTypeEnum.DifferentialRate)
          this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = false;
        this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = true;
      }
      else if (this.ownershipTemplateDetail.vehicleTypeId != this.vehicleTypeEnum.Private_Car && this.claims.RateType != MileageRateTypeEnum.DifferentialRate) {
        this.ukMileageRateSettingConfiguration.isPrivateCarTypeSelected = false;
        this.ukMileageRateSettingConfiguration.isOtherCarTypeSelected = true;
        this.ukMileageRateSettingConfiguration.isResetBussMileDisplay = false;
        this.ukMileageRateSettingConfiguration.isSlabsDivDisplay = true;
      }
    }
    this.resetForm(Number(String(item.vehicleTypeId) + String(item.vehicleSubTypeId)), this.ownershipTemplateDetail.vehicleTypeId, true);
    if (this.ukMileageRateSettingConfiguration.isNewOwnershipType) {
      if (this.PanelData?.currentFinancialYear) {
        let effdateShort = formatDate(this.PanelData?.currentFinancialYear, 'dd-MMM-yyyy', 'en-US');
        let effDateFormat = new Date(effdateShort);
        effDateFormat.setDate(effDateFormat.getDate() - 5);
        this.fnSetCalendar(effDateFormat);
      }
    }


    setTimeout(() => {
      this.formctrl.markAsDirty();
      this.cdRef.detectChanges();
    }, 500);
  }

  fnSetVatRateValue(item: any) {
    if (item.isLink) {
      this.formData.rowData.vatRateName = this.vatRateDetail?.taxCode;
      this.formData.rowData.vatRateId = this.vatRateDetail?.taxRateMasterId;
      this.formctrl.get('vatRateId').setValue(this.vatRateDetail?.taxRateMasterId);
      if (item.isManageLink) {
        this.fnShowTaxSetupStep3(1);
      }
      else {
        this.fnShowTaxSetup();
      }
    }
    else {
      this.vatRateDetail = item;
      this.ukMileageRateSettingConfiguration.vatRateModel = item.taxCode;
      this.ukMileageRateSettingConfiguration.isVatRateDropdown = false;
      this.cdRef.detectChanges();
    }

  }

  fnEditOrgUKMileageRateInfo(item: OrgOwnershipTypeInfo) {
    item.nrFuelRate = Number(item.nrFuelRate).toFixed(mileageRatedigitConfig);
    item.vatRate = item.mileageMultiRateInfoList[0].vatRate;
    item.vatRateId = item.mileageMultiRateInfoList[0].vatRateId;
    item.mileageRate = item.mileageMultiRateInfoList[0].mileageRate;
    this.EditClickAction = true;
    if (!this.selectedOrgUKMileageVehicleTypes.isActive) {
      this.ukMileageRateSettingConfiguration.userActionId = this.uKRateConfigEnum.ActivateOwnerShip;
      this.fnChangeFormHeaderBasedOnUKRateConfigEnum();
    }
    else if (this.selectedOrgUKMileageVehicleTypes.isActive && item.statusCode == this.mileageRateStatusEnum.Active) {
      this.ukMileageRateSettingConfiguration.userActionId = this.uKRateConfigEnum.ActiveRateEdit;
      this.fnChangeFormHeaderBasedOnUKRateConfigEnum();
    }
    else if (this.selectedOrgUKMileageVehicleTypes.isActive && item.statusCode == this.mileageRateStatusEnum.FutureRate) {
      this.ukMileageRateSettingConfiguration.userActionId = this.uKRateConfigEnum.FutureRateEdit;
      this.fnChangeFormHeaderBasedOnUKRateConfigEnum();
    }
    this.orgUKMileageRateInfo = item;
    this.fnInitializeForm();
    this.fnChangeFormHeaderBasedOnUKRateConfigEnum();
    this.cdRef.detectChanges();
    let uniqueId = '';
    for (let i = 0; i < item.mileageMultiRateInfoList.length; i++) {
      uniqueId += item.mileageMultiRateInfoList[i].mileageRateSetupId.toString();
    }
    this.logItemId = uniqueId.toString();
  }
  fnCopyExistingRate() {
    this.ukMileageRateSettingConfiguration.userActionId = this.uKRateConfigEnum.CopyRate;
    this.fnGetOrgUKActiveRateByOrgMapId(this.formctrl.value.orgVehicleTypeMapId);
    this.fnChangeFormHeaderBasedOnUKRateConfigEnum();
  }
  fnCloseForm(action, isRefreshRequired, isUpdatedSortRequired) {

    this.ukMileageRateSettingConfiguration.submitted = false;
    this.vatRateDetail = null;
    this.ukMileageRateSettingConfiguration.vatRateModel = '';
    this.resetForm(null, null);
    this.ukMileageRateSettingConfiguration.isOverlayEnabled = false;
    this.ukMileageRateSettingConfiguration.isAddNewRate = false;
    this.ukMileageRateSettingConfiguration.isOwnershipNameDuplicate = false;
    this.ukMileageRateSettingConfiguration.isRangeToValidationDisplay = false;
    this.fnCloseFormWithAction(action, isRefreshRequired, isUpdatedSortRequired)
  }
  fnCloseFormWithAction(action, isRefreshRequired, isUpdatedSortRequired) {
    let isOnlyFCEnabledVehicle = this.ownershipTemplateDetail && this.ownershipTemplateDetail.vehicleSubTypeId == 5;
    this.closeFormAction = {
      action: action,
      isRefreshRequired: isRefreshRequired,
      isUpdatedSortRequired: isUpdatedSortRequired,
      otherAction: this.isPassengerLoadPurchased && this.passengerLoadDisplay && this.isActive && this.claims?.IsPassengerLoadOn
        ? this.uKRateConfigEnum.ActivateOwnerShip :
        ((isOnlyFCEnabledVehicle && this.isActive && this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewOwnership)
          ? this.uKRateConfigEnum.AddNewOwnership : 0)
    }

    if (this.formData?.rowData?.uniqueRowId > 0) {
      this.closePanelRateImport.emit(this.closeFormAction);
      return;
    }
    this.isOverlayRequired = false;
    if (this.totalActiveVehicleForReferesh != Number(this.formData.totalActiveVehicle)) {
      this.closeFormAction.isRefreshRequired = true;
    }
    this.closePanelEvent.emit(this.closeFormAction);
    this.cdRef.detectChanges();
  }

  BuildFormDynamic(imleageMultiRateInfo: MileageMultiRateInfo, minNum: number): UntypedFormGroup {
    let vehicleTypeId = 0;
    if (this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewRate) {
      vehicleTypeId = this.vehicleTypeDetail != null ? this.vehicleTypeDetail.vehicleTypeId : 0;
    }
    else {
      if (this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewOwnership) {
        vehicleTypeId = this.ownershipTemplateDetail != null ? this.ownershipTemplateDetail.vehicleTypeId : 0;
      }
      else {
        vehicleTypeId = this.selectedOrgUKMileageVehicleTypes != null ? this.selectedOrgUKMileageVehicleTypes.vehicleTypeId : 0;
      }
    }
    if (this.isElectricCar) {
      return this.fb.group({
        amount: [imleageMultiRateInfo.amount],
        mileageRate: [imleageMultiRateInfo.mileageRate != undefined ? Number(imleageMultiRateInfo.mileageRate).toFixed(mileageRatedigitConfig) : '0.00', [Validators.required]],
        milesTravelled: [imleageMultiRateInfo.milesTravelled],
        rangeFrom: [imleageMultiRateInfo.rangeFrom],
        rangeTo: [imleageMultiRateInfo.rangeTo],
        vatRate: [this.fnGetVatRate(imleageMultiRateInfo.vatRateId, true)],
        vatRateId: [imleageMultiRateInfo.vatRateId],
        mileageRateSetupId: [imleageMultiRateInfo.mileageRateSetupId],
        nrFuelRate: [imleageMultiRateInfo.nrFuelRate != undefined ? Number(imleageMultiRateInfo.nrFuelRate).toFixed(mileageRatedigitConfig) : '0.0000', [Validators.required]],
        chargingType: [imleageMultiRateInfo.chargingType || 0],
        isRangeToInvalid: [false]
      });
    }
    if (vehicleTypeId != this.vehicleTypeEnum.Private_Car && this.claims.RateType != MileageRateTypeEnum.DifferentialRate) {
      if (imleageMultiRateInfo.vatRateId != 0) {
        let vatRateName = this.fnGetVatRate(imleageMultiRateInfo.vatRateId, false);
        this.ukMileageRateSettingConfiguration.vatRateModel = vatRateName.toString();
      }
      return this.fb.group({
        amount: [imleageMultiRateInfo.amount],
        mileageRate: [imleageMultiRateInfo.mileageRate != undefined ? Number(imleageMultiRateInfo.mileageRate).toFixed(mileageRatedigitConfig) : imleageMultiRateInfo.mileageRate, [Validators.required]],
        milesTravelled: [imleageMultiRateInfo.milesTravelled],
        rangeFrom: [imleageMultiRateInfo.rangeFrom],
        rangeTo: [imleageMultiRateInfo.rangeTo],
        vatRate: [this.fnGetVatRate(imleageMultiRateInfo.vatRateId, true)],
        vatRateId: [imleageMultiRateInfo.vatRateId],
        mileageRateSetupId: [imleageMultiRateInfo.mileageRateSetupId],
        nrFuelRate: [imleageMultiRateInfo.nrFuelRate != undefined ? Number(imleageMultiRateInfo.nrFuelRate).toFixed(mileageRatedigitConfig) : '0.0000'],
        chargingType: [imleageMultiRateInfo.chargingType || 0],
        isRangeToInvalid: [false]
      });
    }
    else {
      return this.fb.group({
        amount: [imleageMultiRateInfo.amount],
        mileageRate: [imleageMultiRateInfo.mileageRate != undefined ? Number(imleageMultiRateInfo.mileageRate).toFixed(mileageRatedigitConfig) : imleageMultiRateInfo.mileageRate
          , [Validators.required, Validators.min(minNum)]],
        milesTravelled: [imleageMultiRateInfo.milesTravelled],
        rangeFrom: [imleageMultiRateInfo.rangeFrom],
        rangeTo: [imleageMultiRateInfo.rangeTo, [Validators.required, Validators.min(1), Validators.max(999999)]],
        vatRate: [this.fnGetVatRate(imleageMultiRateInfo.vatRateId, true)],
        vatRateId: [imleageMultiRateInfo.vatRateId],
        mileageRateSetupId: [imleageMultiRateInfo.mileageRateSetupId],
        isRangeToInvalid: [false]
      });
    }
  }

  fnOpenAlertWithMessages() {
    this.ukMileageRateSettingConfiguration.popUpModelAlertHeading = this.translate.instant("label_alert");
    this.ukMileageRateSettingConfiguration.popUpModelAlertContant = this.translate.instant("uk_mileage_selected_date_validation_msg");
    this.ukMileageRateSettingConfiguration.popUpModelAlertButtonText = this.translate.instant("uk_mileage_btn_ok");
    this.ukMileageRateSettingConfiguration.popUpModelAlert = true;
    this.isOverlayRequired = false;
  }
  fnOpenDeleteRateConfirmationBox(item: OrgOwnershipTypeInfo) {
    this.orgUKMileageRateInfo = item;
    this.ukMileageRateSettingConfiguration.popUpModelAlertHeading = this.translate.instant("label_alert");
    this.ukMileageRateSettingConfiguration.popUpModelAlertContant = this.translate.instant("delete_future_rate_msg");
    this.ukMileageRateSettingConfiguration.popUpModelAlertButtonText = this.translate.instant("uk_mileage_btn_ok");
    this.ukMileageRateSettingConfiguration.isDeleteRateConfirmationDisplay = true;
    this.isOverlayRequired = false;
  }
  fncloseDeleteRateConfirmationBox() {
    this.isOverlayRequired = true;
    this.ukMileageRateSettingConfiguration.isDeleteRateConfirmationDisplay = false;
  }


  getOrgPurchaseFunctionList() {
    let request = new ApiRequest<IPurchaseFunctionListRequest>(
      "SoloPurchaseFunctionList",
      environment.applicationVersion,
      environment.requestId
    );
    request.requestInfo = new PurchaseFunctionListRequest(this.claims.UserId, this.claims.OrgId);
    this.organisationSettingService
      .soloPurchaseFunctionList(request)
      .subscribe((data: IApiresponse<any>) => {
        if (data.statusCode == 0) {
          if (data.responseInfo.orgPaidFunctionList.length > 0) {
            let purchaseFuncListDetails = data.responseInfo.orgPaidFunctionList[0].paidFunctions;
            let SetupTaxRateFunction = purchaseFuncListDetails.find(
              (x) => x.functionId == FunctionPackageEnum.SetupTaxRate)
            if (SetupTaxRateFunction) {
              this.ukMileageRateSettingConfiguration.isTaxRateFunctionPurchased = true;
            }
            let PassengerLoadMiles = purchaseFuncListDetails.find(
              (x) => x.functionId == FunctionPackageEnum.PassengerLoadMiles)
            if (PassengerLoadMiles) {
              this.isPassengerLoadPurchased = true;
            }

            let fcDetail = purchaseFuncListDetails.find(
              (x) => x.functionId == FunctionPackageEnum.FuelCard)
            if (fcDetail) {
              this.isFCPurchased = true;
            }
            let nrDetail = purchaseFuncListDetails.find(
              (x) => x.functionId == FunctionPackageEnum.NonReimbursableFuel)
            if (nrDetail) {
              this.isNRPurchased = true;
            }
            let docDetail = purchaseFuncListDetails.find(
              (x) => x.functionId == FunctionPackageEnum.DutyofCare)
            if (docDetail) {
              this.isDOCPurchased = true;
            }
          }
        }
        this.GetMasterVehicles();
      });
  }
  fnDeleteOrgUKMileageRateInfo() {
    let effdateShort = formatDate(this.orgUKMileageRateInfo.effectiveFrom, 'dd-MMM-yyyy', 'en-US');
    let apiRequest = new ApiRequest<IValidateEffectiveDateRequest>("DeleteMileageRateSlab", environment.applicationVersion, environment.requestId);
    let request = new ValidateEffectiveDateRequest(this.selectedOrgUKMileageVehicleTypes.orgVehicleTypeMapId, effdateShort);
    request.rateType = this.claims.RateType;
    apiRequest.requestInfo = request;
    this.ukMileageRateSettingService.SoloDeleteMileageRateSlab(apiRequest).pipe(first()).subscribe((res: IApiresponse<ISaveOrgMileageWizardResponse>) => {
      if (res.statusCode == 0) {
        this.toastr.success(this.translate.instant("success"));
        this.ukMileageRateSettingConfiguration.isDeleteRateConfirmationDisplay = false;
        this.fnCloseForm(PanelClosActionEnum.Delete, true, false);
      }
    });
  }

  fnCheckRedirect() {
   this.showTaxRatePopup();
  }

  showTaxRatePopup() {
    this.isOverlayRequired = false;
    this.ukMileageRateSettingConfiguration.showTaxMarketingPopup = true;
    this.taxRatePopupModel = new MarketingPopup(
      this.translate.instant("tax_rate_heading"),
      this.translate.instant("setup_tax_mapketing_popup_text"),
      this.translate.instant("setup_tax_marketing_popup_text1"),
      "",
      "../../assets/svg-icons/Tax_Marketing.svg",
      "../../assets/images/TaxRateMarketingDetails.png",
      "",
      this.functionPackageEnum.SetupTaxRate,
      this.translate.instant("tax_rate_heading"),
      "taxSetup",
      this.functionPackageEnum.TwoStepApproval,
      this.functionPackageEnum.TwoStepApproval
    );
  }
  routerNavigate() {
    let isFree = 'false';
    let packagePath = 'taxSetup';
    let functionPackageName = 'Tax Rate Setup';
    let functionPackageId = this.functionPackageEnum.SetupTaxRate.toString();
    let functionStatus = '0';
    this.router.navigate(['/addtocart'], {
      queryParams: {
        isFree: this.EncryptParameters(isFree),
        'packagePath': this.EncryptParameters(packagePath),
        'functionPackageName': this.EncryptParameters(functionPackageName),
        'functionPackageId': this.EncryptParameters(functionPackageId),
        'functionStatus': this.EncryptParameters(functionStatus)
      }
    });
  }
  EncryptParameters(encryptValue) {
    let rsaHelper = new RSAHelper();
    let encrypt = rsaHelper.Encrypt(encryptValue);
    return encrypt;
  }
  fnSaveCartDetails() {
    let request = new ApiRequest<ICartDetailsRequest>(
      "SaveCartDetails",
      environment.applicationVersion,
      environment.requestId
    );
    request.requestInfo = new CartDetailsRequest(
      0,
      0,
      false,
      this.functionPackageEnum.SetupTaxRate,
      "Tax Rate Setup"
    );
    this.ukMileageRateSettingService
      .SaveCartDetails(request)
      .pipe(first())
      .subscribe(
        data => {
          if (data.statusCode == 0) {
            this.ukMileageRateSettingConfiguration.claims.CartCount += 1;
            this.claimsService.updateClaims(this.ukMileageRateSettingConfiguration.claims);
            this.routerNavigate();
          } else {
            this.toastr.error(data.errorInfo[0].message);
          }
        },
        error => {
          this.toastr.error(error);
        }
      );
  }
  fnCloseMarketingPopUp() {
    this.isOverlayRequired = true;
    this.ukMileageRateSettingConfiguration.showTaxMarketingPopup = false;
  }

  activateValueChanged(event) {
    if (event.target.checked) {
      this.ukMileageRateSettingConfiguration.isActivateValidationDisplay = false;
      if (this.isPassengerLoadPurchased)
        this.passengerLoadDisplay = true;
    }
    else {
      this.ukMileageRateSettingConfiguration.isActivateValidationDisplay = true;
    }
    setTimeout(() => {
      this.formctrl.markAsDirty();
      this.cdRef.detectChanges();
    }, 500);

    this.cdRef.detectChanges();
  }
  fnOwnershipNameKeyPress(event) {
    let inputValue = event.target.value.trim();
    if (inputValue == '') {
      this.formctrl.patchValue({
        vehicleLabel: inputValue
      });
      this.cdRef.detectChanges();
    }


    this.ukMileageRateSettingConfiguration.isOwnershipNameDuplicate = false;
  }

  canDeactivate(): boolean {
    return !this.formctrl.dirty;
  }

  observeUnsavedChangesAlerts() {
    this.userActionEventSubscription = this.alertService.getUserActionEvent().subscribe(action => {
      if (action) {
        this.fnCloseForm(PanelClosActionEnum.Close, false, false);
      }
    });
  }

  closePanel() {
    if (!this.canDeactivate()) {
      this.showUnsavedChangesAlert();
    }
    else {
      this.fnCloseForm(PanelClosActionEnum.Close, false, false);
    }
  }

  ngOnDestroy() {
    this.userActionEventSubscription.unsubscribe();
    this.tourService.destroyParallelPopups();
  }
  
  fnDisabledSave() {
    if (!this.formctrl.dirty) {
      return true;
    }
    else {
      return false;
    }
  }
  fnDisplayAddRateButton() {
    if (this.formData) {
      if (this.formData.userActionId && (this.formData.userActionId == UKRateConfigEnum.AddNewRate
        || this.formData.userActionId == UKRateConfigEnum.AddNewOwnership
        || this.formData.userActionId == UKRateConfigEnum.CopyRate
        || this.formData.userActionId == UKRateConfigEnum.ActivateOwnerShip)) {
        return false;
      }
      else {
        if (this.EditClickAction && !(this.formData?.rowData?.uniqueRowId > 0)) {
          return true;
        }
        else { return false; }

      }
    }
  }
  fnTooltipMileageRate() {
    if (this.claims.RateType != MileageRateTypeEnum.FreeForLife) {
      return this.translate.instant("mileage_rate_msg1");
    }
  }

  fnMileageRateEnable() {
    if (this.isFCassignedToOwnership) {
      this.formctrl.controls.mileageRate.setValidators(null);
      this.formctrl.controls.mileageRate.updateValueAndValidity();
      this.cdRef.detectChanges();
    }
  }

  GetOrgVehicleNRFCDetails(rowData): void {
    let request = new ApiRequest<IOrgVehiclesNRFCRequest>(
      "SoloGetOrgVehicleNRFCDetails",
      environment.applicationVersion,
      environment.requestId
    );
    this.requestVehicleTypes.nrfcStatus = NRFCStatusEnum.FC;
    request.requestInfo = this.requestVehicleTypes;
    this.nrFcService
      .SoloGetOrgVehicleNRFCDetails(request)
      .subscribe((res: IApiresponse<IOrgVehiclesNRFCResponse>) => {
        let vehicleTypeSummary = res.responseInfo.vehicleTypes;
        let fc = vehicleTypeSummary.find(
          (x) => x.orgVehicleTypeMapId == rowData.orgVehicleTypeMapId && x.nrfcStatus == NRFCStatusEnum.FC)
        if (fc) {
          if (this.isFCPurchased) {
            this.isFCassignedToOwnership = true;
          }
        }
        this.fnEditOrgUKMileageRateInfo(rowData);
      });
  }
  mileageRatesCalculationMethodsPanel: any;
  showSetupMileageRatesCalculationMethods = false;

  showOwnershipAlertPopup: boolean = false;
  OwnershipAlertPopupModel = new AlertPanelModel(false, "", [""], "", "", true, "");
  showUnsavedChangesAlertPopup: boolean = false;
  UnsavedChangesAlertPopupModel = new AlertPanelModel(false, "", [""], "", "", true, "");
  showMileageRateChangeAlertPopup: boolean = false;
  MileageRateChangeAlertPopupModel = new AlertPanelModel(false, "", [""], "", "", true, "");
  bodyClass: string = "block padding-top-10 padding-bottom-10";
  hideInfoIcon: boolean = false;
  singleMessageTextClass: string = "";
  ShowOwnershipAlertPanel() {

    let msg = [];
    let ownershipName = '';
    if (this.selectedOrgUKMileageVehicleTypes.vehicleTypeId == this.vehicleTypeEnum.Company_Car) {
      ownershipName = this.translate.instant("ownership_inactive_msg6") + " " + this.selectedOrgUKMileageVehicleTypes.derivedName + "-" + this.formctrl.value.vehicleLabel + " " + this.translate.instant("ownership_inactive_msg8");
    }
    else {
      ownershipName = this.translate.instant("ownership_inactive_msg6") + " " + this.formctrl.value.vehicleLabel + " " + this.translate.instant("ownership_inactive_msg8");
    }
    msg.push({
      iconClass: 'fas fa-exclamation-circle color-red align-middle',
      textHtml: '<span class="padding-left-5">' + ownershipName + '</span>'
    });
    msg.push({
      iconClass: 'fas fa-exclamation-circle text-mustard align-middle',
      textHtml: '<span class="padding-left-5">' + this.translate.instant("ownership_inactive_msg1") + '</span>'
    });
    if (this.formData.totalActiveVehicle) {
      msg.push({
        iconClass: 'fas fa-exclamation-circle text-mustard align-middle',
        textHtml: '<span class="padding-left-5">' + this.translate.instant("show_all_vehicle_msg1") + '</span>'
      });
    }


    if (this.formData.futureRateCount) {
      msg.push({
        iconClass: 'fas fa-exclamation-circle color-red align-middle',
        textHtml: '<span class="padding-left-5">' + this.translate.instant("ownership_inactive_msg2") + '</span>'
      });
    }
    this.OwnershipAlertPopupModel = new AlertPanelModel(
      true,
      this.translate.instant("label_alert"),
      [],
      this.translate.instant("cancel"),
      this.translate.instant("label_confirm"),
      true
      , this.translate.instant("ownership_inactive_msg1")
    );
    this.OwnershipAlertPopupModel.htmlMessage = msg
    if (this.OwnershipAlertPopupModel.hideInfoIcon) {
      this.hideInfoIcon = this.OwnershipAlertPopupModel.hideInfoIcon;
    }
    if (this.OwnershipAlertPopupModel.bodyClass) {
      this.bodyClass = this.OwnershipAlertPopupModel.bodyClass;
    }
    if (this.OwnershipAlertPopupModel.singleMessagetextClass) {
      this.singleMessageTextClass = this.OwnershipAlertPopupModel.singleMessagetextClass;
    }
    this.showOwnershipAlertPopup = true;
  }
  fnOwnershipAlertPopupReceiver(receiveValue) {

    this.showOwnershipAlertPopup = false;
    this.OwnershipAlertPopupModel = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
    if (receiveValue) {
      this.ukMileageRateSettingConfiguration.isActivateValidationDisplay = false;
      this.onSubmit();
    }
  }

  showUnsavedChangesAlert() {
    this.UnsavedChangesAlertPopupModel = new AlertPanelModel(
      true,
      this.translate.instant("label_alert"),
      [this.translate.instant("Are you sure you want to navigate away without saving the changes?")],
      this.translate.instant("cancel"),
      this.translate.instant("label_confirm"),
      true,
      ""
    );
    this.showUnsavedChangesAlertPopup = true;
  }

  fnUnsavedChangesAlertPopupReceiver(receiveValue) {
    this.showUnsavedChangesAlertPopup = false;
    this.UnsavedChangesAlertPopupModel = new AlertPanelModel(false, "", [""], "", "", true, "");
    if (receiveValue) {
      this.fnCloseForm(PanelClosActionEnum.Close, false, false);
    }
  }

  showMileageRateChangeAlert() {
    const alertMessage = [
      "Some Claimants have made Mileage expenses. Hence, you cannot change the rate.",
      "If you are in a Trial, then you must Delete all the transactions, and then amend the rate.",
      "Else, create a new rate, with Tomorrow's Effective date."
    ];

    this.MileageRateChangeAlertPopupModel = new AlertPanelModel(
      true,
      this.translate.instant("label_alert"),
      alertMessage,
      this.translate.instant("cancel"),
      "Create New Rate",
      true,
      ""
    );
    this.showMileageRateChangeAlertPopup = true;
  }

  fnMileageRateChangeAlertPopupReceiver(receiveValue) {
    this.showMileageRateChangeAlertPopup = false;
    this.MileageRateChangeAlertPopupModel = new AlertPanelModel(false, "", [""], "", "", true, "");
    if (receiveValue) {
      this.fnCopyExistingRate();
    }
  }

  fnOpenAssignVehicleForClaimant() {
    this.fnOwnershipAlertPopupReceiver(false);
    let orgVehicleTypeMapId
    if (this.ukMileageRateSettingConfiguration.userActionId == this.uKRateConfigEnum.AddNewRate) {
      orgVehicleTypeMapId = this.vehicleTypeDetail.orgVehicleTypeMapId;
    }
    else if (this.ukMileageRateSettingConfiguration.userActionId != this.uKRateConfigEnum.AddNewOwnership) {
      orgVehicleTypeMapId = this.selectedOrgUKMileageVehicleTypes.orgVehicleTypeMapId;
    }
    this.openAssignVehicleEvent.emit({
      panelHeading: this.translate.instant("assign_vehicle_to_claimants"),
      orgVehicleTypeMapId: orgVehicleTypeMapId
    });
  }
  sanitizerHtml(element) {
    let safeText = this.sanitizer.bypassSecurityTrustHtml(element);
    return safeText;
  }

  setClasses() {
    let divClass = '';
    if (this.OwnershipAlertPopupModel.bodyClass) {
      divClass = this.OwnershipAlertPopupModel.bodyClass;
    }
    else {
      divClass = 'block padding-top-10 padding-bottom-10';
    }
    return divClass;
  }

  showStep1: boolean;
  showStep2: boolean;
  showStep3: boolean;
  fmSpecialObject: any;
  panelHeader: string;
  closeBtnText: string;
  fnShowTaxSetup() {
    this.fmSpecialObject = { type: 1 };
    this.showStep1 = true;
    this.panelHeader = this.translate.instant('receipt_type_text4');
    this.closeBtnText = this.translate.instant('label_close');
    //this.hideWatchVideo=true;
  }
  fnCloseTaxSetup(fmSpecialObject?: any) {
    this.showStep1 = false;
    this.BindTaxSetup();
    if (fmSpecialObject?.nextPanel) {
      this.fnShowTaxSetupStep2();
    }
  }
  fnShowTaxSetupStep2() {
    this.fmSpecialObject = { type: 1 };
    this.showStep2 = true;
    this.panelHeader = this.translate.instant('self_setup_msg_1');
    this.closeBtnText = this.translate.instant('label_close');
  }
  fnCloseTaxSetupStep2(fmSpecialObject?: any) {
    this.showStep2 = false;
    this.BindTaxSetup();
    if (fmSpecialObject?.nextPanel) {
      setTimeout(() => {
        this.fnShowTaxSetupStep3(2);
      }, 100);
    }
  }
  fnShowTaxSetupStep3(type: number) {
    this.fmSpecialObject = { type: type };
    this.showStep3 = true;
    this.panelHeader = this.translate.instant('self_setup_msg_2');
    this.closeBtnText = this.translate.instant('label_close');
  }
  fnCloseTaxSetupStep3() {
    this.showStep3 = false;
    this.BindTaxSetup();
  }

  fnStartTour() {
    const showTour = Boolean(this.route.snapshot.queryParams?.showTour);
    if (!showTour) return;

    if (!document.querySelector(`#mileage-rate-setting-guide`)) return;

    this.tourService.showParallelFromRegistry('manage-mileage-rate-panel-tour');
  }



  fnUpdateElectricCardValidators(cardIndex: number) {
    const isEnabled = cardIndex === 0 ? this.homeChargingEnabled : this.thirdPartyChargingEnabled;
    const cardGroup = this.mileageMultiRateInfoListArray.at(cardIndex);
    if (!cardGroup) return;
    if (isEnabled) {
      cardGroup.get('mileageRate').setValidators([Validators.required]);
      cardGroup.get('nrFuelRate').setValidators([Validators.required]);
    } else {
      cardGroup.get('mileageRate').clearValidators();
      cardGroup.get('mileageRate').setErrors(null);
      cardGroup.get('nrFuelRate').clearValidators();
      cardGroup.get('nrFuelRate').setErrors(null);
    }
    cardGroup.get('mileageRate').updateValueAndValidity();
    cardGroup.get('nrFuelRate').updateValueAndValidity();
    this.cdRef.detectChanges();
  }

  fnSetVatRateValueForElectricCard(item: any, cardIndex: number) {
    const cardGroup = this.mileageMultiRateInfoListArray.at(cardIndex);
    if (item.isLink) {
      cardGroup.get('vatRateId').setValue(this.vatRateDetail?.taxRateMasterId);
      cardGroup.markAsPristine();
      if (item.isManageLink) {
        this.fnShowTaxSetupStep3(1);
      }
      else {
        this.fnShowTaxSetup();
      }
    } else {
      this.formctrl.markAsDirty();
    }
  }

  fnSetMaxFuelRateForElectricCard(cardIndex: number) {
    this.formctrl.markAsDirty();
    this.cdRef.detectChanges();
  }

  fnValidateElectricCarRates(): boolean {
    if (!this.homeChargingEnabled && !this.thirdPartyChargingEnabled) {
      this.ukMileageRateSettingConfiguration.popUpModelAlertHeading = this.translate.instant('label_alert');
      this.ukMileageRateSettingConfiguration.popUpModelAlertContant = this.translate.instant('at_least_one_charging_type');
      this.ukMileageRateSettingConfiguration.popUpModelAlertButtonText = this.translate.instant('uk_mileage_btn_ok');
      this.ukMileageRateSettingConfiguration.isEffectiveFromValidation = true;
      this.isOverlayRequired = false;
      return false;
    }
    this.fnUpdateElectricCardValidators(0);
    this.fnUpdateElectricCardValidators(1);
    let hasErrors = false;
    for (let i = 0; i < this.mileageMultiRateInfoListArray.length; i++) {
      const isEnabled = i === 0 ? this.homeChargingEnabled : this.thirdPartyChargingEnabled;
      if (!isEnabled) continue;
      const cardGroup = this.mileageMultiRateInfoListArray.at(i);
      const mileageRate = parseFloat(cardGroup.get('mileageRate').value) || 0;
      const nrFuelRate = parseFloat(cardGroup.get('nrFuelRate').value) || 0;
      if (mileageRate === 0) {
        cardGroup.get('mileageRate').setErrors({ 'cannotBeZero': true });
        hasErrors = true;
      }
      if (nrFuelRate === 0) {
        cardGroup.get('nrFuelRate').setErrors({ 'cannotBeZero': true });
        hasErrors = true;
      } else if (nrFuelRate > 0 && mileageRate > 0 && nrFuelRate > mileageRate) {
        cardGroup.get('nrFuelRate').setErrors({ 'max': { max: mileageRate, actual: nrFuelRate } });
        hasErrors = true;
      }
    }
    this.cdRef.detectChanges();
    if (hasErrors) return false;
    return true;
  }
}
